import { sanearDescuentosConfig } from '../config/descuentos';
// Mock API — simula el backend de Manuel con datos en memoria
// Negocio demo: "Café mezo" (cafetería en Medellín)
// Los nombres de campos coinciden con el backend real para que
// cambiar REACT_APP_USE_MOCK=false no requiera tocar el frontend.

function delay() {
  return new Promise(r => setTimeout(r, 300 + Math.random() * 300));
}

let _idCounter  = 1000;
let _saleCounter = 87;
function nextId()   { return 'mock-' + (++_idCounter); }
function nextSale() { return ++_saleCounter; }

// ─── Datos iniciales ────────────────────────────────────────────────────────

// Campos del negocio alineados con el backend de Manuel
const NEGOCIO_DEMO = {
  id:          'neg-001',
  name:        'Café mezo',
  type:        'CAFE',
  phone:       '3121234567',
  address:     'El Poblado, Cra 37 #10A-45',
  city:        'Medellín',
  country:     'Colombia',
  openingTime: '07:00',
  closingTime: '22:00',
  tableCount:  6,
  isOpen:      true,
  // Sin plan, ProtectedRoute (self-serve 0044) manda todo a /planes y el
  // modo mock queda inutilizable — el demo arranca con Pro activo.
  planId:      'pro',
  planStatus:  'activo',
  // Asistencia con evidencia (0050): el demo arranca con el punto del local
  // (El Poblado) y AMBAS exigencias encendidas para mostrar el flujo completo
  // foto + GPS de /mi-turno. Fuera del punto no bloquea.
  ubicacionLat:           6.2095,
  ubicacionLng:           -75.5676,
  radioAsistenciaM:       150,
  asistenciaRequiereFoto: true,
  asistenciaRequiereLlave: false,
  // Medios de pago (0060): la demo trae uno CUSTOM ("Bancolombia QR") para
  // que se vea que la lista es del negocio, no de mezo. Comisiones (0065 +
  // 0066a): el datáfono trae el caso real del piloto, 2,69 % + $300 por
  // venta, para que Reportes y mezoIA muestren "te queda" con datos.
  metodosPago: { lista: [
    { id: 'efectivo', nombre: 'Efectivo',       tipo: 'CASH', fijo: true, comision_pct: 0,    comision_fija: 0 },
    { id: 'datafono', nombre: 'Datáfono',       tipo: 'BOLD',             comision_pct: 2.69, comision_fija: 300 },
    { id: 'nequi',    nombre: 'Nequi',          tipo: 'NEQUI',            comision_pct: 0,    comision_fija: 0 },
    { id: 'qrbanco',  nombre: 'Bancolombia QR', tipo: 'TRANSFER',         comision_pct: 0,    comision_fija: 0 },
  ] },
  // Descuentos con autorización (0067): la demo pide PIN cuando la rebaja
  // supera el 10 % (se ve el flujo sin configurar nada).
  descuentosConfig: { requiere_autorizacion: true, tope_pct: 10, tope_monto: 0 },
  // La demo trae el checklist ACTIVO para que se vea la función sin configurar.
  checklistConfig: {
    activo: true,
    apertura: ['Encender equipos y luces', 'Desinfectar mesones', 'Contar el fondo de caja', 'Abrir puertas'],
    cierre:   ['Lavar loza y menaje', 'Cuadre de caja', 'Sacar la basura', 'Cerrar y asegurar puertas'],
  },
  // GPS oculto a pedido del piloto (2026-09-05) — paridad con produccion.
  asistenciaRequiereGps:  false,
  // Permisos por rol del negocio (0052, paridad con businesses.permisos_roles):
  // el demo trae un override de ejemplo para que la pestaña "Roles y
  // permisos" se vea "personalizado" (el cajero de Café mezo sí puede
  // quitar productos de la mesa). Solo diferencias con el default de mezo.
  permisosRoles: { CASHIER: { 'pos.anular_linea': true } },
};

const CATEGORIAS_INIT = [
  { id: 'cat-1', nombre: 'Bebidas calientes', emoji: '☕', orden: 1 },
  { id: 'cat-2', nombre: 'Jugos y fríos',     emoji: '🧃', orden: 2 },
  { id: 'cat-3', nombre: 'Panadería',         emoji: '🥐', orden: 3 },
  { id: 'cat-4', nombre: 'Platos',            emoji: '🍽️', orden: 4 },
];

const PRODUCTOS_INIT = [
  // costo = costo real de producción en COP (ingredientes + empaque)
  { id: 'p-01',  nombre: 'Café tinto',         precio: 3000,  costo: 700,   categoriaId: 'cat-1', emoji: '☕',  disponible: true, creadoEn: new Date('2025-01-15') },
  { id: 'p-02',  nombre: 'Café americano',      precio: 4500,  costo: 1100,  categoriaId: 'cat-1', emoji: '☕',  disponible: true, creadoEn: new Date('2025-01-15') },
  { id: 'p-03',  nombre: 'Café con leche',      precio: 5500,  costo: 1800,  categoriaId: 'cat-1', emoji: '🥛',  disponible: true, creadoEn: new Date('2025-01-15') },
  { id: 'p-04',  nombre: 'Capuchino',           precio: 6500,  costo: 2200,  categoriaId: 'cat-1', emoji: '☕',  disponible: true, creadoEn: new Date('2025-01-15') },
  { id: 'p-05',  nombre: 'Latte de vainilla',   precio: 7000,  costo: 2600,  categoriaId: 'cat-1', emoji: '🥛',  disponible: true, creadoEn: new Date('2025-01-15') },
  { id: 'p-06',  nombre: 'Chocolate caliente',  precio: 5500,  costo: 2100,  categoriaId: 'cat-1', emoji: '🍫',  disponible: true, creadoEn: new Date('2025-01-15') },
  { id: 'p-07',  nombre: 'Agua de panela',      precio: 3000,  costo: 400,   categoriaId: 'cat-1', emoji: '🍵',  disponible: true, creadoEn: new Date('2025-01-15') },
  { id: 'p-08',  nombre: 'Jugo de lulo',        precio: 5000,  costo: 1600,  categoriaId: 'cat-2', emoji: '🍋',  disponible: true, creadoEn: new Date('2025-01-15') },
  { id: 'p-09',  nombre: 'Jugo de maracuyá',    precio: 5500,  costo: 1800,  categoriaId: 'cat-2', emoji: '🟡',  disponible: true, creadoEn: new Date('2025-01-15') },
  { id: 'p-10',  nombre: 'Jugo de mora',        precio: 5000,  costo: 1700,  categoriaId: 'cat-2', emoji: '🫐',  disponible: true, creadoEn: new Date('2025-01-15') },
  { id: 'p-11',  nombre: 'Limonada de coco',    precio: 6000,  costo: 2200,  categoriaId: 'cat-2', emoji: '🥥',  disponible: true, creadoEn: new Date('2025-01-15') },
  { id: 'p-12',  nombre: 'Agua mineral',        precio: 2500,  costo: 800,   categoriaId: 'cat-2', emoji: '💧',  disponible: true, creadoEn: new Date('2025-01-15') },
  { id: 'p-13',  nombre: 'Croissant de jamón',  precio: 4500,  costo: 2000,  categoriaId: 'cat-3', emoji: '🥐',  disponible: true, creadoEn: new Date('2025-01-15') },
  { id: 'p-14',  nombre: 'Pan de bono',         precio: 2500,  costo: 800,   categoriaId: 'cat-3', emoji: '🧀',  disponible: true, creadoEn: new Date('2025-01-15') },
  { id: 'p-15',  nombre: 'Empanada de pipián',  precio: 3500,  costo: 1400,  categoriaId: 'cat-3', emoji: '🥟',  disponible: true, creadoEn: new Date('2025-01-15') },
  { id: 'p-16',  nombre: 'Arepa con queso',     precio: 5000,  costo: 1900,  categoriaId: 'cat-3', emoji: '🫓',  disponible: true, creadoEn: new Date('2025-01-15') },
  { id: 'p-17',  nombre: 'Buñuelo',             precio: 2000,  costo: 600,   categoriaId: 'cat-3', emoji: '🍩',  disponible: true, creadoEn: new Date('2025-01-15') },
  { id: 'p-18',  nombre: 'Changua',             precio: 8000,  costo: 3500,  categoriaId: 'cat-4', emoji: '🍲',  disponible: true, creadoEn: new Date('2025-01-15') },
  { id: 'p-19',  nombre: 'Calentado paisa',     precio: 12000, costo: 5200,  categoriaId: 'cat-4', emoji: '🍳',  disponible: true, creadoEn: new Date('2025-01-15') },
  { id: 'p-20',  nombre: 'Sopa del día',        precio: 14000, costo: 6800,  categoriaId: 'cat-4', emoji: '🥣',  disponible: true, creadoEn: new Date('2025-01-15') },
  { id: 'p-21',  nombre: 'Ensalada del chef',   precio: 15000, costo: 5500,  categoriaId: 'cat-4', emoji: '🥗',  disponible: true, creadoEn: new Date('2025-01-15') },
  { id: 'p-22',  nombre: 'Sancocho de pollo',   precio: 18000, costo: 9000,  categoriaId: 'cat-4', emoji: '🍗',  disponible: true, creadoEn: new Date('2025-01-15') },
  { id: 'p-23',  nombre: 'Bandeja paisa mini',  precio: 25000, costo: 11000, categoriaId: 'cat-4', emoji: '🍽️', disponible: true, creadoEn: new Date('2025-01-15') },
];

const MESAS_INIT = [
  {
    id: 'mesa-1', numero: 1, nombre: 'Mesa 1', estado: 'ocupada',
    ocupadaEn: new Date(Date.now() - 45 * 60000), total: 27000, personas: 3,
    lineas: [
      { productId: 'p-04', nombre: 'Capuchino',        precio: 6500, cantidad: 2, subtotal: 13000 },
      { productId: 'p-13', nombre: 'Croissant de jamón', precio: 4500, cantidad: 2, subtotal: 9000  },
      { productId: 'p-08', nombre: 'Jugo de lulo',     precio: 5000, cantidad: 1, subtotal: 5000  },
    ],
  },
  { id: 'mesa-2', numero: 2, nombre: 'Mesa 2', estado: 'libre',   ocupadaEn: null, total: null, lineas: null },
  {
    id: 'mesa-3', numero: 3, nombre: 'Mesa 3', estado: 'pagando',
    ocupadaEn: new Date(Date.now() - 92 * 60000), total: 45000, personas: 4,
    lineas: [
      { productId: 'p-23', nombre: 'Bandeja paisa mini', precio: 25000, cantidad: 1, subtotal: 25000 },
      { productId: 'p-08', nombre: 'Jugo de lulo',       precio: 5000,  cantidad: 2, subtotal: 10000 },
      { productId: 'p-01', nombre: 'Café tinto',         precio: 3000,  cantidad: 2, subtotal: 6000  },
      { productId: 'p-17', nombre: 'Buñuelo',            precio: 2000,  cantidad: 2, subtotal: 4000  },
    ],
  },
  { id: 'mesa-4', numero: 4, nombre: 'Mesa 4', estado: 'libre',   ocupadaEn: null, total: null, lineas: null },
  {
    id: 'mesa-5', numero: 5, nombre: 'Mesa 5', estado: 'ocupada',
    ocupadaEn: new Date(Date.now() - 22 * 60000), total: 13500, personas: 2,
    lineas: [
      { productId: 'p-08', nombre: 'Jugo de lulo', precio: 5000, cantidad: 1, subtotal: 5000 },
      { productId: 'p-04', nombre: 'Capuchino',    precio: 6500, cantidad: 1, subtotal: 6500 },
      { productId: 'p-17', nombre: 'Buñuelo',      precio: 2000, cantidad: 1, subtotal: 2000 },
    ],
  },
  { id: 'mesa-6', numero: 6, nombre: 'Mesa 6', estado: 'libre',   ocupadaEn: null, total: null, lineas: null },
];

// `permisos` = overrides por empleado (paridad con team_members.permisos, 0049).
// María (cajera) tiene un override de ejemplo: puede quitar productos de la mesa.
const EMPLEADOS_INIT = [
  { id: 'emp-1', nombre: 'Juanes Lizcano',  correo: 'juanes@cafemezo.co', pin: '1234', roles: ['admin'],   permisos: {},                           activo: true, creadoEn: new Date('2025-01-15') },
  { id: 'emp-2', nombre: 'María García',    correo: 'maria@cafemezo.co',  pin: '2345', roles: ['cajera'],  permisos: { 'pos.anular_linea': true }, activo: true, creadoEn: new Date('2025-01-20') },
  { id: 'emp-3', nombre: 'Carlos Muñoz',    correo: 'carlos@cafemezo.co', pin: '3456', roles: ['mesero'],  permisos: {},                           activo: true, creadoEn: new Date('2025-02-01') },
];

// Genera órdenes históricas para los reportes (ya con campos del backend)
function generarOrdenesDemo() {
  const ordenes = [];
  const hoy = new Date();

  // paymentMethod usa los enums del backend en mayúsculas
  const plantillas = [
    { items: [{ productId: 'p-02', name: 'Café americano', unitPrice: 4500, quantity: 2, subtotal: 9000 }, { productId: 'p-13', name: 'Croissant de jamón', unitPrice: 4500, quantity: 2, subtotal: 9000 }], paymentMethod: 'CASH' },
    { items: [{ productId: 'p-04', name: 'Capuchino', unitPrice: 6500, quantity: 3, subtotal: 19500 }, { productId: 'p-16', name: 'Arepa con queso', unitPrice: 5000, quantity: 2, subtotal: 10000 }], paymentMethod: 'NEQUI' },
    { items: [{ productId: 'p-18', name: 'Changua', unitPrice: 8000, quantity: 2, subtotal: 16000 }, { productId: 'p-01', name: 'Café tinto', unitPrice: 3000, quantity: 2, subtotal: 6000 }], paymentMethod: 'CARD' },
    { items: [{ productId: 'p-22', name: 'Sancocho de pollo', unitPrice: 18000, quantity: 1, subtotal: 18000 }, { productId: 'p-08', name: 'Jugo de lulo', unitPrice: 5000, quantity: 1, subtotal: 5000 }], paymentMethod: 'CASH' },
    { items: [{ productId: 'p-03', name: 'Café con leche', unitPrice: 5500, quantity: 4, subtotal: 22000 }, { productId: 'p-15', name: 'Empanada de pipián', unitPrice: 3500, quantity: 4, subtotal: 14000 }], paymentMethod: 'TRANSFER' },
    { items: [{ productId: 'p-05', name: 'Latte de vainilla', unitPrice: 7000, quantity: 2, subtotal: 14000 }, { productId: 'p-14', name: 'Pan de bono', unitPrice: 2500, quantity: 3, subtotal: 7500 }], paymentMethod: 'DAVIPLATA' },
    { items: [{ productId: 'p-23', name: 'Bandeja paisa mini', unitPrice: 25000, quantity: 2, subtotal: 50000 }, { productId: 'p-11', name: 'Limonada de coco', unitPrice: 6000, quantity: 2, subtotal: 12000 }], paymentMethod: 'CASH' },
    { items: [{ productId: 'p-19', name: 'Calentado paisa', unitPrice: 12000, quantity: 3, subtotal: 36000 }, { productId: 'p-06', name: 'Chocolate caliente', unitPrice: 5500, quantity: 3, subtotal: 16500 }], paymentMethod: 'NEQUI' },
    { items: [{ productId: 'p-21', name: 'Ensalada del chef', unitPrice: 15000, quantity: 2, subtotal: 30000 }, { productId: 'p-12', name: 'Agua mineral', unitPrice: 2500, quantity: 2, subtotal: 5000 }], paymentMethod: 'CARD' },
    { items: [{ productId: 'p-02', name: 'Café americano', unitPrice: 4500, quantity: 1, subtotal: 4500 }, { productId: 'p-17', name: 'Buñuelo', unitPrice: 2000, quantity: 2, subtotal: 4000 }], paymentMethod: 'CASH' },
  ];

  const horarios  = [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];
  const empleados = ['María García', 'Carlos Muñoz', 'Juanes Lizcano'];

  for (let dia = 0; dia < 30; dia++) {
    const fecha = new Date(hoy);
    fecha.setDate(fecha.getDate() - dia);

    const esFinde   = fecha.getDay() === 0 || fecha.getDay() === 6;
    const numOrdenes = esFinde
      ? 8 + Math.floor(Math.random() * 6)
      : 4 + Math.floor(Math.random() * 5);

    for (let i = 0; i < numOrdenes; i++) {
      const plantilla  = plantillas[i % plantillas.length];
      const hora       = horarios[Math.floor(Math.random() * horarios.length)];
      const minuto     = Math.floor(Math.random() * 60);
      const createdAt  = new Date(fecha);
      createdAt.setHours(hora, minuto, 0, 0);

      if (createdAt > hoy) continue;

      const subtotal = plantilla.items.reduce((s, l) => s + l.subtotal, 0);
      ordenes.push({
        id:           nextId(),
        status:       'PAID',
        items:        plantilla.items,
        subtotal,
        tip:          null,
        total:        subtotal,
        paymentMethod: plantilla.paymentMethod,
        saleNumber:   nextSale(),
        createdAt,
        employeeName: empleados[Math.floor(Math.random() * empleados.length)],
      });
    }
  }

  return ordenes.sort((a, b) => b.createdAt - a.createdAt);
}

// ─── Órdenes de cocina demo (muestran los tres estados del timer) ────────────

const COCINA_DEMO = [
  {
    id: 'coc-001', status: 'OPEN', estadoCocina: 'preparando',
    cocinaEn: new Date(Date.now() - 2.5 * 60000),
    items: [
      { productId: 'p-04', name: 'Capuchino',        unitPrice: 6500, quantity: 2, subtotal: 13000 },
      { productId: 'p-13', name: 'Croissant de jamón', unitPrice: 4500, quantity: 1, subtotal: 4500  },
    ],
    subtotal: 17500, total: 17500, tip: null, paymentMethod: null, saleNumber: null,
    tableId: 'mesa-1', employeeName: 'Carlos Muñoz', shiftId: null,
    createdAt: new Date(Date.now() - 2.5 * 60000),
  },
  {
    id: 'coc-002', status: 'OPEN', estadoCocina: 'preparando',
    cocinaEn: new Date(Date.now() - 7.5 * 60000),
    items: [
      { productId: 'p-18', name: 'Changua',       unitPrice: 8000, quantity: 2, subtotal: 16000 },
      { productId: 'p-07', name: 'Agua de panela', unitPrice: 3000, quantity: 2, subtotal: 6000  },
    ],
    subtotal: 22000, total: 22000, tip: null, paymentMethod: null, saleNumber: null,
    tableId: 'mesa-3', employeeName: 'María García', shiftId: null,
    createdAt: new Date(Date.now() - 7.5 * 60000),
  },
  {
    id: 'coc-003', status: 'OPEN', estadoCocina: 'preparando',
    cocinaEn: new Date(Date.now() - 11 * 60000),
    items: [
      { productId: 'p-19', name: 'Calentado paisa', unitPrice: 12000, quantity: 1, subtotal: 12000 },
      { productId: 'p-01', name: 'Café tinto',      unitPrice: 3000,  quantity: 2, subtotal: 6000  },
    ],
    subtotal: 18000, total: 18000, tip: null, paymentMethod: null, saleNumber: null,
    tableId: 'mesa-5', employeeName: 'Juanes Lizcano', shiftId: null,
    createdAt: new Date(Date.now() - 11 * 60000),
  },
];

// ─── Estado mutable en memoria ───────────────────────────────────────────────

// ─── Clientes y lealtad ──────────────────────────────────────────────────────
// Mapa celular → { celular, visitas, ultimaVisita }

const DB_CLIENTES = {};

export async function getCliente(celular) {
  await delay();
  return DB_CLIENTES[celular] ?? null;
}

export async function registrarVisita(celular) {
  await delay();
  if (!DB_CLIENTES[celular]) {
    DB_CLIENTES[celular] = { celular, visitas: 0, ultimaVisita: null };
  }
  DB_CLIENTES[celular].visitas    += 1;
  DB_CLIENTES[celular].ultimaVisita = new Date();
  return DB_CLIENTES[celular];
}

// ─── Estado mutable en memoria ───────────────────────────────────────────────

const ZONAS_INIT = [
  { id: 'zona-1', nombre: 'Salón principal', color: '#C8903F' },
];

const DB = {
  // role y planType alineados con los enums del backend
  users: [
    {
      id:            'user-001',
      email:         'admin@cafemezo.co',
      password:      'demo1234',
      negocioId:     'neg-001',
      role:          'ADMIN',
      planType:      'PRO',
      planExpiresAt: null,
    },
  ],
  negocios:     { 'neg-001': { ...NEGOCIO_DEMO } },
  categorias:   [...CATEGORIAS_INIT],
  productos:    PRODUCTOS_INIT.map(p => ({ ...p, negocioId: 'neg-001' })),
  zonas:        [...ZONAS_INIT],
  mesas:        MESAS_INIT.map(m => ({ ...m, negocioId: 'neg-001', zonaId: 'zona-1' })),
  cuentas:      [],
  ordenes:      [...COCINA_DEMO, ...generarOrdenesDemo()].map(o => ({ ...o, negocioId: 'neg-001' })),
  empleados:    EMPLEADOS_INIT.map(e => ({ ...e, negocioId: 'neg-001' })),
  movimientos:  [],
  turnos:       [],
  pendingOtps:  {},
  currentUserId: null,
};

// ─── Helpers de autenticación ─────────────────────────────────────────────────

// Crea un JWT mock con los campos que devuelve el backend real
function crearToken(user, expiresInSec = 86400) {
  const payload = {
    sub:           user.id,
    email:         user.email,
    role:          user.role,
    planType:      user.planType,
    planExpiresAt: user.planExpiresAt ?? null,
    iat:           Math.floor(Date.now() / 1000),
    exp:           Math.floor(Date.now() / 1000) + expiresInSec,
  };
  return 'mock.' + btoa(JSON.stringify(payload)) + '.sig';
}

function usuarioActual() {
  if (DB.currentUserId) {
    return DB.users.find(u => u.id === DB.currentUserId) ?? null;
  }
  // Al recargar la página el estado RAM se pierde.
  // Recuperamos el userId desde el accessToken guardado en localStorage.
  try {
    const token = typeof localStorage !== 'undefined' ? localStorage.getItem('mezo_token') : null;
    if (!token) return null;
    const payload = JSON.parse(atob(token.split('.')[1]));
    const userId = payload.sub ?? payload.uid;
    if (userId) {
      DB.currentUserId = userId;  // restaurar para llamadas siguientes
      return DB.users.find(u => u.id === userId) ?? null;
    }
  } catch { /* token inválido o entorno sin localStorage */ }
  return null;
}

function negocioActual() {
  return usuarioActual()?.negocioId ?? null;
}

// ─── Auth ─────────────────────────────────────────────────────────────────────

export async function getMyRole() {
  // En mock siempre es el dueño
  return 'ADMIN';
}

// Paridad con api.getMisPermisos (0049). El usuario mock (user-001) es ADMIN
// para que el demo público /demo vea todo; si el correo logueado coincide con
// un empleado mock, se devuelven su rol y overrides (útil para probar la UI
// de un mesero/cajero sin Supabase).
export async function getMisPermisos() {
  const user = usuarioActual();
  const emp  = user ? DB.empleados.find(e => e.correo === user.email) : null;
  const ROL  = { admin: 'ADMIN', cajera: 'CASHIER', cajero: 'CASHIER', mesero: 'WAITER', cocina: 'KITCHEN' };
  const permisosRoles = _permisosRolesMock();
  if (emp) {
    return { rol: ROL[emp.roles?.[0]] ?? 'CASHIER', overrides: emp.permisos ?? {}, permisos: null, permisosRoles };
  }
  return { rol: user?.role ?? 'ADMIN', overrides: {}, permisos: null, permisosRoles };
}

// ─── Permisos por rol del negocio (0052) ─────────────────────────────────────
// Paridad con api.getPermisosRoles / guardarPermisosRoles. Viven en memoria
// del negocio demo (NEGOCIO_DEMO.permisosRoles) y se espejan en localStorage
// para sobrevivir el refresh del demo público — si no, lo que el visitante
// guardaba en "Roles y permisos" se esfumaba al recargar.
const PERMISOS_ROLES_KEY_MOCK = 'mezo_permisos_roles_mock';

function _permisosRolesMock() {
  const negId = negocioActual();
  const neg   = negId ? DB.negocios[negId] : null;
  if (!neg) return {};
  try {
    const raw = typeof localStorage !== 'undefined' ? localStorage.getItem(PERMISOS_ROLES_KEY_MOCK) : null;
    if (raw) {
      const guardado = JSON.parse(raw);
      if (guardado && typeof guardado === 'object') neg.permisosRoles = guardado;
    }
  } catch { /* noop */ }
  return (neg.permisosRoles && typeof neg.permisosRoles === 'object') ? neg.permisosRoles : {};
}

export async function getPermisosRoles() {
  await delay();
  return { ..._permisosRolesMock() };
}

export async function guardarPermisosRoles(permisos) {
  await delay();
  const user = usuarioActual();
  if (!user?.negocioId || !DB.negocios[user.negocioId]) throw new Error('No autenticado.');
  // Misma validación que la RPC: objeto {ROL: {permiso: boolean}}, sin ADMIN.
  const limpio = {};
  for (const [rol, ov] of Object.entries((permisos && typeof permisos === 'object') ? permisos : {})) {
    if (String(rol).toUpperCase() === 'ADMIN') throw new Error('El administrador siempre puede todo: su rol no se edita');
    if (!ov || typeof ov !== 'object') continue;
    const fila = {};
    for (const [k, v] of Object.entries(ov)) if (typeof v === 'boolean') fila[k] = v;
    if (Object.keys(fila).length) limpio[String(rol).toUpperCase()] = fila;
  }
  DB.negocios[user.negocioId].permisosRoles = limpio;
  try { localStorage.setItem(PERMISOS_ROLES_KEY_MOCK, JSON.stringify(limpio)); } catch { /* noop */ }
  return { ...limpio };
}

export async function login(email, password) {
  await delay();

  const emailValido = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const passValida  = typeof password === 'string' && password.length >= 6;
  if (!emailValido || !passValida) {
    throw Object.assign(new Error('Correo o contraseña incorrectos.'), { status: 401 });
  }

  const demoUser = DB.users[0];
  DB.currentUserId = demoUser.id;

  // Respuesta idéntica al backend: accessToken + refreshToken + user
  return {
    accessToken:  crearToken({ ...demoUser, email }, 86400),
    refreshToken: crearToken({ ...demoUser, email }, 604800),
    user: {
      id:            demoUser.id,
      email,
      role:          demoUser.role,
      planType:      demoUser.planType,
      planExpiresAt: demoUser.planExpiresAt,
    },
  };
}

export async function register(email, password) {
  await delay();
  if (DB.users.find(u => u.email === email)) {
    throw Object.assign(new Error('Ya existe una cuenta con ese correo.'), { status: 409 });
  }
  const newUser = {
    id:            nextId(),
    email,
    password,
    negocioId:     null,
    role:          'ADMIN',
    planType:      'SEMILLA',
    planExpiresAt: null,
  };
  DB.users.push(newUser);
  // OTP fijo para demo: 123456
  DB.pendingOtps[email] = { code: '123456', userId: newUser.id, expiresAt: Date.now() + 5 * 60000 };
  return { email, message: 'Código enviado a ' + email };
}

export async function verifyOtp(email, code) {
  await delay();
  const otp = DB.pendingOtps[email];
  if (!otp)                   throw Object.assign(new Error('No hay código pendiente para este correo.'), { status: 400 });
  if (Date.now() > otp.expiresAt) throw Object.assign(new Error('El código expiró. Reenvíalo.'), { status: 400 });
  if (otp.code !== code)      throw Object.assign(new Error('Código incorrecto.'), { status: 400 });

  delete DB.pendingOtps[email];
  const user = DB.users.find(u => u.id === otp.userId);
  if (!user) throw new Error('Usuario no encontrado.');
  DB.currentUserId = user.id;

  // Misma forma de respuesta que login
  return {
    accessToken:  crearToken(user, 86400),
    refreshToken: crearToken(user, 604800),
    user: {
      id:            user.id,
      email:         user.email,
      role:          user.role,
      planType:      user.planType,
      planExpiresAt: user.planExpiresAt,
    },
  };
}

export async function resendOtp(email) {
  await delay();
  const user = DB.users.find(u => u.email === email);
  if (!user) throw Object.assign(new Error('Correo no encontrado.'), { status: 404 });
  DB.pendingOtps[email] = { code: '123456', userId: user.id, expiresAt: Date.now() + 5 * 60000 };
  return { message: 'Código reenviado.' };
}

// ─── Negocio ──────────────────────────────────────────────────────────────────

// Respuesta con los campos del backend de Manuel
export async function getNegocio() {
  await delay();
  const user = usuarioActual();
  if (!user?.negocioId) return null;
  return DB.negocios[user.negocioId] ?? null;
}

export async function createNegocio(data) {
  await delay();
  const user = usuarioActual();
  if (!user) throw new Error('No autenticado.');
  const id = nextId();

  // Guardar con los campos del backend (name, type, phone, etc.)
  const negocio = { id, ...data, isOpen: true };
  DB.negocios[id] = negocio;
  user.negocioId  = id;

  if (data.tableCount > 0) {
    for (let i = 1; i <= data.tableCount; i++) {
      DB.mesas.push({ id: nextId(), negocioId: id, numero: i, nombre: `Mesa ${i}`, estado: 'libre', ocupadaEn: null, total: null });
    }
  }

  return negocio;
}

export async function updateNegocio(data) {
  await delay();
  const user = usuarioActual();
  if (!user?.negocioId) throw new Error('No autenticado.');
  DB.negocios[user.negocioId] = { ...DB.negocios[user.negocioId], ...data };
  return DB.negocios[user.negocioId];
}

// ─── Productos ────────────────────────────────────────────────────────────────

export async function getProductos() {
  await delay();
  const negId = negocioActual();
  if (!negId) return [];
  return [...DB.productos]
    .filter(p => p.negocioId === negId)
    .sort((a, b) => b.creadoEn - a.creadoEn)
    // Paridad con fromProduct del backend (migración 0040): receta + inventario
    // asociado siempre presentes — si el producto no los tiene, caen al default.
    .map(p => ({
      ...p,
      recetaPasos:        Array.isArray(p.recetaPasos) ? p.recetaPasos : [],
      inventarioAsociado: p.inventarioAsociado ?? { activo: false, items: [] },
    }));
}

export async function createProducto(data) {
  await delay();
  const user = usuarioActual();
  const p = { id: nextId(), negocioId: user?.negocioId ?? null, ...data, creadoEn: new Date() };
  DB.productos.push(p);
  return p;
}

export async function updateProducto(id, data) {
  await delay();
  const idx = DB.productos.findIndex(p => p.id === id);
  if (idx === -1) throw new Error('Producto no encontrado.');
  DB.productos[idx] = { ...DB.productos[idx], ...data };
  return DB.productos[idx];
}

export async function deleteProducto(id) {
  await delay();
  DB.productos = DB.productos.filter(p => p.id !== id);
  return { ok: true };
}

// ─── Categorías ───────────────────────────────────────────────────────────────

export async function getCategorias() {
  await delay();
  return [...DB.categorias].sort((a, b) => a.orden - b.orden);
}

export async function createCategoria(data) {
  await delay();
  const c = { id: nextId(), ...data };
  DB.categorias.push(c);
  return c;
}

export async function updateCategoria(id, data) {
  await delay();
  const idx = DB.categorias.findIndex(c => c.id === id);
  if (idx === -1) throw new Error('Categoría no encontrada.');
  DB.categorias[idx] = { ...DB.categorias[idx], ...data };
  return DB.categorias[idx];
}

export async function deleteCategoria(id) {
  await delay();
  const tieneProductos = DB.productos.some(p => p.categoriaId === id);
  if (tieneProductos) throw new Error('No puedes eliminar una categoría con productos.');
  DB.categorias = DB.categorias.filter(c => c.id !== id);
  return { ok: true };
}

// ─── Mesas ────────────────────────────────────────────────────────────────────

export async function getMesas() {
  await delay();
  const negId = negocioActual();
  if (!negId) return [];
  return [...DB.mesas]
    .filter(m => m.negocioId === negId)
    .sort((a, b) => a.numero - b.numero)
    // Paridad con fromTable del backend: estos campos siempre existen (null si
    // la mesa no tiene orden activa ni posición en el plano del salón).
    .map(m => ({ activeOrderId: null, activeStatus: null, posX: null, posY: null, ...m }));
}

export async function updateMesa(id, data) {
  await delay();
  const idx = DB.mesas.findIndex(m => m.id === id);
  if (idx === -1) throw new Error('Mesa no encontrada.');
  const sanitized = Object.fromEntries(
    Object.entries(data).map(([k, v]) => [k, v === 'serverTimestamp' ? new Date() : v])
  );
  // Plano del salón (paridad 0043): posX/posY se guardan sobre la mesa mock
  // para que el modo "Organizar" funcione también en demo.
  if (data.posX !== undefined) sanitized.posX = data.posX == null ? null : Number(data.posX);
  if (data.posY !== undefined) sanitized.posY = data.posY == null ? null : Number(data.posY);
  DB.mesas[idx] = { ...DB.mesas[idx], ...sanitized };
  return DB.mesas[idx];
}

export async function createMesa(data) {
  await delay();
  const user = usuarioActual();
  const negId = user?.negocioId ?? null;
  const mesasPropias = negId ? DB.mesas.filter(m => m.negocioId === negId) : DB.mesas;
  const siguienteNumero = mesasPropias.length
    ? Math.max(...mesasPropias.map(m => m.numero)) + 1
    : 1;
  const numero = data.numero ?? siguienteNumero;
  const mesa = {
    id:        nextId(),
    negocioId: negId,
    numero,
    nombre:    data.nombre ?? `Mesa ${numero}`,
    estado:    'libre',
    ocupadaEn: null,
    total:     null,
    lineas:    null,
    zonaId:    data.zonaId ?? 'zona-1',
  };
  DB.mesas.push(mesa);
  return mesa;
}

export async function deleteMesa(id) {
  await delay();
  const idx = DB.mesas.findIndex(m => m.id === id);
  if (idx === -1) throw new Error('Mesa no encontrada.');
  DB.mesas.splice(idx, 1);
  return { ok: true };
}

// ─── Zonas ────────────────────────────────────────────────────────────────────

export async function getZonas() {
  await delay();
  return [...DB.zonas];
}

export async function createZona(data) {
  await delay();
  const zona = { id: nextId(), ...data };
  DB.zonas.push(zona);
  return zona;
}

export async function updateZona(id, data) {
  await delay();
  const idx = DB.zonas.findIndex(z => z.id === id);
  if (idx === -1) throw new Error('Zona no encontrada.');
  DB.zonas[idx] = { ...DB.zonas[idx], ...data };
  return DB.zonas[idx];
}

export async function deleteZona(id) {
  await delay();
  const tieneMesas = DB.mesas.some(m => m.zonaId === id);
  if (tieneMesas) throw new Error('No puedes eliminar una zona que tiene mesas asignadas.');
  DB.zonas = DB.zonas.filter(z => z.id !== id);
  return { ok: true };
}

export async function cambiarMesa(origenId, destinoId) {
  await delay();
  const origen  = DB.mesas.find(m => m.id === origenId);
  const destino = DB.mesas.find(m => m.id === destinoId);
  if (!origen || !destino) throw new Error('Mesa no encontrada.');

  const totalOrigen    = origen.total;
  const lineasOrigen   = origen.lineas ?? null;
  const personasOrigen = origen.personas ?? null;

  Object.assign(origen,  { estado: 'libre',   ocupadaEn: null,       total: null,         lineas: null,        personas: null });
  Object.assign(destino, { estado: 'ocupada', ocupadaEn: new Date(), total: totalOrigen,  lineas: lineasOrigen, personas: personasOrigen });

  return { ok: true };
}

// ─── Cuentas ──────────────────────────────────────────────────────────────────

export async function getCuentas() {
  await delay();
  return DB.cuentas.filter(c => c.estado !== 'pagada').sort((a, b) => b.creadoEn - a.creadoEn);
}

export async function createCuenta(data) {
  await delay();
  const cuenta = { id: nextId(), ...data, creadoEn: new Date() };
  DB.cuentas.push(cuenta);
  return cuenta;
}

export async function updateCuenta(id, data) {
  await delay();
  const idx = DB.cuentas.findIndex(c => c.id === id);
  if (idx === -1) throw new Error('Cuenta no encontrada.');
  DB.cuentas[idx] = { ...DB.cuentas[idx], ...data };
  return DB.cuentas[idx];
}

export async function getCuenta(id) {
  await delay();
  const cuenta = DB.cuentas.find(c => c.id === id);
  if (!cuenta) throw new Error('Cuenta no encontrada.');
  return cuenta;
}

// ─── Órdenes — flujo de 3 pasos ───────────────────────────────────────────────
//
// Paso 1: createOrden  → POST /orders        → status OPEN
// Paso 2: deliverOrden → POST /orders/{id}/deliver → status DELIVERED
// Paso 3: createVenta  → POST /sales         → status PAID + devuelve la venta

export async function getOrdenes(params = {}) {
  await delay();
  const negId = negocioActual();
  if (!negId) return [];
  let result = DB.ordenes.filter(o => o.negocioId === negId);
  if (params.desde) {
    const desde = new Date(params.desde);
    result = result.filter(o => new Date(o.createdAt) >= desde);
  }
  if (params.hasta) {
    const hasta = new Date(params.hasta);
    result = result.filter(o => new Date(o.createdAt) <= hasta);
  }
  return result.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
}

// Paso 1 — crea la orden con estado OPEN y la marca automáticamente como "preparando" en cocina
export async function createOrden(data) {
  await delay();
  const ahora = new Date();
  const orden = {
    id:            nextId(),
    negocioId:     usuarioActual()?.negocioId ?? null,
    status:        'OPEN',
    estadoCocina:  'preparando',
    cocinaEn:      ahora,
    items:         data.items ?? [],
    subtotal:      data.items?.reduce((s, i) => s + i.subtotal, 0) ?? 0,
    tip:           null,
    total:         data.items?.reduce((s, i) => s + i.subtotal, 0) ?? 0,
    paymentMethod: null,
    saleNumber:    null,
    tableId:       data.tableId ?? null,
    employeeName:  data.employeeName ?? null,
    shiftId:       data.shiftId ?? null,
    createdAt:     ahora,
  };
  DB.ordenes.unshift(orden);
  return orden;
}

// Paso 2 — marca la orden como entregada (DELIVERED)
export async function deliverOrden(id) {
  await delay();
  const idx = DB.ordenes.findIndex(o => o.id === id);
  if (idx === -1) throw new Error('Orden no encontrada.');
  DB.ordenes[idx] = { ...DB.ordenes[idx], status: 'DELIVERED' };
  return DB.ordenes[idx];
}

// Paso 3 — cierra la venta con método de pago; retorna la venta creada
export async function createVenta(data) {
  await delay();
  const idx = DB.ordenes.findIndex(o => o.id === data.orderId);
  if (idx === -1) throw new Error('Orden no encontrada.');

  const saleNumber = nextSale();

  // Actualizar la orden al estado final PAID
  DB.ordenes[idx] = {
    ...DB.ordenes[idx],
    status:       'PAID',
    paymentMethod: data.paymentMethod,
    subtotal:     data.subtotal,
    tip:          data.tip ?? null,
    total:        data.total,
    comentario:   (data.comentario ?? '').trim().slice(0, 200) || null,
    metodoNombre: (data.metodoNombre ?? '').trim().slice(0, 40) || null,
    pagos:        Array.isArray(data.pagos) ? data.pagos : [],
    saleNumber,
    ventaId:      `sale-${data.orderId}`,
  };

  return {
    id:            `sale-${data.orderId}`,
    saleNumber,
    orderId:       data.orderId,
    paymentMethod: data.paymentMethod,
    subtotal:      data.subtotal,
    tip:           data.tip ?? null,
    total:         data.total,
    amountPaid:    data.amountPaid ?? null,
    change:        data.change ?? null,
    comentario:    (data.comentario ?? '').trim().slice(0, 200) || null,
    metodoNombre:  (data.metodoNombre ?? '').trim().slice(0, 40) || null,
    createdAt:     new Date(),
  };
}

export async function updateOrden(id, data) {
  await delay();
  const idx = DB.ordenes.findIndex(o => o.id === id);
  if (idx === -1) throw new Error('Orden no encontrada.');
  DB.ordenes[idx] = { ...DB.ordenes[idx], ...data };
  return DB.ordenes[idx];
}

// ─── Empleados ────────────────────────────────────────────────────────────────

export async function getEmpleados() {
  await delay();
  const negId = negocioActual();
  if (!negId) return [];
  return [...DB.empleados].filter(e => e.negocioId === negId).sort((a, b) => a.nombre.localeCompare(b.nombre));
}

export async function createEmpleado(data) {
  await delay();
  const user = usuarioActual();
  const emp = { id: nextId(), negocioId: user?.negocioId ?? null, ...data, activo: true, creadoEn: new Date() };
  DB.empleados.push(emp);
  return emp;
}

// ─── PIN de empleados (paridad con 0053) ────────────────────────────────────
// En mock no hay hash: se guarda el PIN igual, pero la API que consume la UI es
// la MISMA que en producción, así el formulario se prueba de verdad en /demo.
export async function getEstadoPines() {
  await delay();
  const mapa = {};
  DB.empleados.forEach((e) => {
    mapa[e.id] = { tienePin: Boolean(e.pin), bloqueado: false, bloqueadoHasta: null };
  });
  return mapa;
}

export async function setPinEmpleado(empleadoId, pin) {
  await delay();
  const limpio = String(pin ?? '').replace(/\D/g, '').slice(0, 4);
  const e = DB.empleados.find((x) => x.id === empleadoId);
  if (e) e.pin = limpio || null;
  return { ok: true, tienePin: Boolean(limpio) };
}

export async function updateEmpleado(id, data) {
  await delay();
  const idx = DB.empleados.findIndex(e => e.id === id);
  if (idx === -1) throw new Error('Empleado no encontrado.');
  DB.empleados[idx] = { ...DB.empleados[idx], ...data };
  return DB.empleados[idx];
}

export async function deleteEmpleado(id) {
  await delay();
  DB.empleados = DB.empleados.filter(e => e.id !== id);
  return { ok: true };
}

// ─── Movimientos de caja ─────────────────────────────────────────────────────

export async function getMovimientos(fecha) {
  await delay();
  const ref = fecha ? new Date(fecha) : new Date();
  ref.setHours(0, 0, 0, 0);
  const fin = new Date(ref);
  fin.setDate(fin.getDate() + 1);
  return DB.movimientos.filter(m => {
    const d = new Date(m.creadoEn);
    return d >= ref && d < fin;
  });
}

export async function createMovimiento(data) {
  await delay();
  const mov = { id: nextId(), ...data, creadoEn: new Date() };
  DB.movimientos.push(mov);
  return mov;
}

// ─── Turnos ───────────────────────────────────────────────────────────────────

export async function getTurnoActivo() {
  await delay();
  return DB.turnos.find(t => t.fin === null) ?? null;
}

export async function createTurno(data) {
  await delay();
  const turno = { id: nextId(), ...data, fin: null, duracionMin: null, numOrdenes: 0, inicio: new Date() };
  DB.turnos.push(turno);
  return turno;
}

export async function updateTurno(id, data) {
  await delay();
  const idx = DB.turnos.findIndex(t => t.id === id);
  if (idx === -1) throw new Error('Turno no encontrado.');
  DB.turnos[idx] = { ...DB.turnos[idx], ...data };
  return DB.turnos[idx];
}

// ─── Ventas (paridad con api.getVentas) ──────────────────────────────────────
// En mock no hay tabla sales aparte: createVenta deja en la orden PAID el
// total final (con propina, canje descontado), así que ese total ES el
// equivalente de sales.total. Derivamos las ventas desde las órdenes pagadas.

export async function getVentas(params = {}) {
  const ordenes = await getOrdenes(params);
  return ordenes
    .filter(o => o.status === 'PAID')
    .map(o => {
      const total = Number(o.total) || 0;
      // En mock `tip` puede ser objeto {percentage, amount} o número.
      const tip = Number(o.tip?.amount ?? o.tip ?? 0) || 0;
      return {
        id:            `sale-${o.id}`,
        orderId:       o.id,
        paymentMethod: o.paymentMethod ?? 'CASH',
        total,               // plata real que entró a la caja
        tip,                 // propina incluida dentro de `total`
        neto: total - tip,   // venta sin propina (subtotal − canje)
        comentario: o.comentario ?? null,
        metodoNombre: o.metodoNombre ?? null,
        cliente: o.clienteVenta ?? null,
        pagos: (o.pagos ?? []).map((p) => ({ tipo: p.tipo, metodo: p.tipo === 'BOLD' ? 'CARD' : p.tipo, nombre: p.nombre ?? null, monto: p.monto })),
        createdAt: o.createdAt,
      };
    });
}

// ─── Reportes / KPIs ─────────────────────────────────────────────────────────
// Misma convención que api.js: "ventas" = neto sin propinas, canjes descontados.

export async function getKPIs(desde, hasta) {
  await delay();
  const ventas = await getVentas({ desde, hasta });

  const totalVentas = ventas.reduce((s, v) => s + v.neto, 0);
  const numOrdenes  = ventas.length;
  const ticketProm  = numOrdenes ? Math.round(totalVentas / numOrdenes) : 0;

  const porHora = {};
  ventas.forEach(v => {
    const h = new Date(v.createdAt).getHours();
    porHora[h] = (porHora[h] || 0) + 1;
  });
  const mejorHora = Object.entries(porHora).sort((a, b) => b[1] - a[1])[0]?.[0] ?? null;

  const porProducto = {};
  DB.ordenes
    .filter(o => o.status === 'PAID' && ventas.some(v => v.orderId === o.id))
    .forEach(o => (o.items ?? []).forEach(i => {
      porProducto[i.name] = (porProducto[i.name] || 0) + i.quantity;
    }));
  const productoTop = Object.entries(porProducto).sort((a, b) => b[1] - a[1])[0]?.[0] ?? null;

  const porMetodo = {};
  ventas.forEach(v => {
    if (v.paymentMethod) porMetodo[v.paymentMethod] = (porMetodo[v.paymentMethod] || 0) + 1;
  });
  const metodoTop = Object.entries(porMetodo).sort((a, b) => b[1] - a[1])[0]?.[0] ?? null;

  return { totalVentas, numOrdenes, ticketProm, mejorHora: mejorHora != null ? Number(mejorHora) : null, productoTop, metodoTop };
}

export async function getVentasPorDia(desde, hasta) {
  await delay();
  const ventas = await getVentas({ desde, hasta });

  const porDia = {};
  ventas.forEach(v => {
    const fecha = new Date(v.createdAt);
    const key   = `${fecha.getFullYear()}-${String(fecha.getMonth() + 1).padStart(2, '0')}-${String(fecha.getDate()).padStart(2, '0')}`;
    porDia[key] = (porDia[key] || 0) + v.neto;
  });

  return Object.entries(porDia)
    .map(([fecha, total]) => ({ fecha, total }))
    .sort((a, b) => a.fecha.localeCompare(b.fecha));
}

// ─── Estado del día (mock — en memoria + localStorage para persistir refresh) ─

const DIA_KEY_MOCK = 'mezo_dia_estado';
const HIST_KEY_MOCK = 'mezo_arqueo_historico';

export async function getDiaActivo() {
  await delay();
  try {
    const raw = localStorage.getItem(DIA_KEY_MOCK);
    if (!raw) return { diaAbierto: false, abiertaAt: null, diaId: null };
    const e = JSON.parse(raw);
    return { diaAbierto: !!e.diaAbierto, abiertaAt: e.abiertaAt ?? null, diaId: e.diaId ?? null, base: Number(e.base) || 0 };
  } catch {
    return { diaAbierto: false, abiertaAt: null, diaId: null, base: 0 };
  }
}

// Paridad con api.abrirDia(base): la base de caja (0048) también se persiste
// en mock — sin esto, en el demo público la base que escribía el visitante se
// perdía y el arqueo nunca cuadraba.
export async function abrirDia(base = 0) {
  await delay();
  const baseNum = Math.max(0, Math.round(Number(base) || 0));
  const estado = { diaAbierto: true, abiertaAt: new Date().toISOString(), diaId: nextId(), base: baseNum };
  try { localStorage.setItem(DIA_KEY_MOCK, JSON.stringify(estado)); } catch { /* noop */ }
  return estado;
}

export async function cerrarDia(arqueo = null) {
  await delay();
  if (arqueo) {
    try {
      const prev = JSON.parse(localStorage.getItem(HIST_KEY_MOCK) ?? '[]');
      prev.push(arqueo);
      localStorage.setItem(HIST_KEY_MOCK, JSON.stringify(prev));
    } catch { /* noop */ }
  }
  const estado = { diaAbierto: false, abiertaAt: null, diaId: null };
  try { localStorage.setItem(DIA_KEY_MOCK, JSON.stringify(estado)); } catch { /* noop */ }
  return estado;
}

export async function getHistoricoArqueos() {
  await delay();
  try {
    return JSON.parse(localStorage.getItem(HIST_KEY_MOCK) ?? '[]')
      .slice().reverse();
  } catch {
    return [];
  }
}

// ═════════════════════════════════════════════════════════════════════════════
// PARIDAD CON api.js — funciones que index.js reenvía y faltaban en el mock.
// Todo vive en memoria (misma filosofía del resto del archivo) y las formas de
// retorno imitan las del backend real para que el modo demo funcione completo.
// ═════════════════════════════════════════════════════════════════════════════

// ─── Subida de archivos (mock: devuelven URLs placeholder) ───────────────────

// Logo del negocio: en demo no hay Storage — devolvemos un placeholder y lo
// guardamos en el negocio para que la UI lo muestre de inmediato.
export async function uploadLogoNegocio(file) {
  await delay();
  if (!file) return null;
  const url = `https://placehold.co/240x240/C8903F/080706?text=Logo&v=${Date.now()}`;
  const negId = negocioActual();
  if (negId && DB.negocios[negId]) DB.negocios[negId].logoUrl = url;
  return url;
}

// Menú en PDF: igual que el real, guarda la URL y cambia el modo del menú.
export async function uploadMenuPdf(file) {
  await delay();
  if (!file) return null;
  const negId = negocioActual();
  const url = `https://placehold.co/600x800/C8903F/080706?text=Menu+PDF&v=${Date.now()}`;
  if (negId && DB.negocios[negId]) {
    DB.negocios[negId].menuPdfUrl = url;
    DB.negocios[negId].menuModo   = 'pdf';
  }
  return url;
}

// Imagen de cabecera del menú público.
export async function uploadMenuHeader(file) {
  await delay();
  if (!file) return null;
  const negId = negocioActual();
  const url = `https://placehold.co/800x300/C8903F/080706?text=Cabecera&v=${Date.now()}`;
  if (negId && DB.negocios[negId]) DB.negocios[negId].menuImagenHeader = url;
  return url;
}

// Foto de UN producto: el caller la guarda con create/updateProducto({ imagenUrl }).
export async function uploadImagenProducto(file) {
  await delay();
  if (!file) return null;
  return `https://placehold.co/400x300/C8903F/080706?text=Producto&v=${Date.now()}`;
}

// Sugerencias de Pexels: en demo no hay edge function — lista vacía y la UI
// muestra su mensaje de "sin fotos".
export async function sugerirImagenes(query) {
  await delay();
  return [];
}

// Avatar del empleado: placeholder + se guarda en el empleado mock.
export async function subirAvatarEmpleado(empleadoId, file) {
  await delay();
  if (!file) return null;
  const url = `https://placehold.co/96x96/C8903F/080706?text=:)&v=${Date.now()}`;
  const emp = DB.empleados.find(e => e.id === empleadoId);
  if (emp) emp.avatarUrl = url;
  return url;
}

// Evidencia de venta: el real devuelve el path relativo dentro del bucket.
export async function subirEvidenciaVenta(saleId, blob) {
  await delay();
  if (!saleId || !blob) return null;
  return `${negocioActual() ?? 'neg-001'}/${saleId}-${Date.now()}.jpg`;
}

// Signed URL de una evidencia: en demo devolvemos un placeholder visible.
export async function urlEvidenciaVenta(path, segundosValidez = 600) {
  await delay();
  if (!path) return null;
  return 'https://placehold.co/600x800/C8903F/080706?text=Evidencia';
}

// ─── Menú QR / DIAN (no-ops en demo) ─────────────────────────────────────────

// Analítica del menú QR: en demo no alimenta nada.
export async function trackMenuView(businessId) {
  if (!businessId) return null;
  return { ok: true };
}

// Factura electrónica DIAN: fire-and-forget igual que el real (que tampoco
// devuelve nada). En demo no hay Factus, así que no hace nada.
export function emitirFacturaDian(saleId) {
  if (!saleId) return null;
  return null;
}

// ─── Flujo de mesas (tomar pedido → cocina sin cobrar) ───────────────────────

// Normaliza un ítem del carrito a línea de orden mock. Toleramos las dos
// convenciones (español del carrito / inglés del backend) igual que api.js.
function _lineaDesdeItem(i, orderId) {
  const nombre   = i.nombre ?? i.name ?? 'Producto';
  const precio   = Number(i.precio ?? i.unitPrice ?? 0);
  const cantidad = Number(i.cantidad ?? i.quantity ?? 1);
  return {
    id:        nextId(),           // id de línea — necesario para quitarLineaOrden
    orderId,
    productId: i.productId ?? i.id ?? null,
    name:      nombre,
    nombre,
    unitPrice: precio,
    precio,
    quantity:  cantidad,
    cantidad,
    // Descuento por línea (0062) y quién lo autorizó (0067): paridad con fromOrderLine.
    descuentoMonto:         Math.max(0, Math.round(Number(i.descuentoMonto ?? i.descuento_monto ?? 0))),
    descuentoMotivo:        i.descuentoMotivo ?? i.descuento_motivo ?? null,
    descuentoAutorizadoPor: i.descuentoAutorizadoPor ?? i.descuento_autorizado_por ?? null,
    descuentoAutorizadoId:  i.descuentoAutorizadoId ?? i.descuento_autorizado_id ?? null,
    subtotal:  precio * cantidad - Math.max(0, Math.round(Number(i.descuentoMonto ?? i.descuento_monto ?? 0))),
    nota:      i.nota ?? i.notas ?? null,
  };
}

// Mantiene la mesa mock alineada con su orden activa (en el backend real esto
// lo hace fromTable uniendo tables + orders; aquí lo sincronizamos a mano).
function _sincronizarMesaConOrden(orden) {
  const mesa = DB.mesas.find(m => m.id === orden.tableId);
  if (!mesa) return;

  if (!['OPEN', 'PREPARING', 'READY', 'DELIVERED'].includes(orden.status)) {
    // Orden cancelada/cerrada → la mesa queda libre
    Object.assign(mesa, {
      estado: 'libre', ocupadaEn: null, total: null, lineas: null,
      personas: null, activeOrderId: null, activeStatus: null,
    });
    return;
  }

  Object.assign(mesa, {
    estado:        orden.status === 'DELIVERED' ? 'pagando' : 'ocupada',
    ocupadaEn:     mesa.ocupadaEn ?? new Date(),
    total:         orden.total,
    // Misma forma que fromTable: id + orderId para poder quitar líneas desde el panel
    lineas:        orden.items.map(l => ({
      id: l.id, orderId: orden.id, productId: l.productId,
      nombre: l.nombre, precio: l.precio, cantidad: l.cantidad, subtotal: l.subtotal,
    })),
    activeOrderId: orden.id,
    activeStatus:  orden.status,
  });
}

// Devuelve la orden activa de una mesa o null (para anexar en vez de duplicar).
export async function getOrdenAbiertaPorMesa(tableId) {
  await delay();
  if (!tableId) return null;
  const activas = ['OPEN', 'PREPARING', 'READY', 'DELIVERED'];
  const orden = DB.ordenes
    .filter(o => o.tableId === tableId && activas.includes(o.status))
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0];
  if (!orden) return null;
  // Igual que fromOrder: las líneas se exponen también como `lineas`
  return { ...orden, lineas: orden.items };
}

// Envía un pedido de mesa a cocina: crea orden OPEN o anexa a la existente.
// Devuelve { ordenId, total } igual que el backend real.
export async function enviarPedidoMesa(tableId, items, opts = {}) {
  await delay();
  if (!tableId)       throw new Error('table_required');
  if (!items?.length) throw new Error('items_required');

  const activas = ['OPEN', 'PREPARING', 'READY'];
  let orden = DB.ordenes
    .filter(o => o.tableId === tableId && activas.includes(o.status))
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0] ?? null;

  if (!orden) {
    const ahora = new Date();
    orden = {
      id:            nextId(),
      negocioId:     negocioActual() ?? 'neg-001',
      status:        'OPEN',
      estadoCocina:  'preparando',
      cocinaEn:      ahora,
      items:         [],
      subtotal:      0,
      tip:           null,
      total:         0,
      paymentMethod: null,
      saleNumber:    null,
      tableId,
      employeeName:  opts.employeeName ?? null,
      employeeId:    opts.employeeId ?? null,
      shiftId:       null,
      createdAt:     ahora,
    };
    DB.ordenes.unshift(orden);
  }

  const nuevas   = items.map(i => _lineaDesdeItem(i, orden.id));
  orden.items    = [...orden.items, ...nuevas];
  orden.subtotal = orden.items.reduce((s, l) => s + (l.subtotal ?? 0), 0);
  orden.total    = orden.subtotal;

  _sincronizarMesaConOrden(orden);
  return { ordenId: orden.id, total: orden.total };
}

// Cancela una orden (liberar mesa sin cobrar). No genera venta.
export async function cancelarOrden(orderId) {
  await delay();
  if (!orderId) return null;
  const orden = DB.ordenes.find(o => o.id === orderId);
  if (!orden) return { ok: true };   // idempotente: ya no existe, nada que hacer
  orden.status       = 'CANCELLED';
  orden.estadoCocina = null;
  _sincronizarMesaConOrden(orden);   // libera la mesa asociada
  return { ok: true };
}

// Quita UNA línea de la orden y recalcula el total.
export async function quitarLineaOrden(orderId, lineId) {
  await delay();
  if (!orderId || !lineId) throw new Error('order_id_y_line_id_requeridos');
  const orden = DB.ordenes.find(o => o.id === orderId);
  if (!orden) throw new Error('Orden no encontrada.');
  orden.items    = (orden.items ?? []).filter(l => l.id !== lineId);
  orden.subtotal = orden.items.reduce((s, l) => s + (l.subtotal ?? 0), 0);
  orden.total    = orden.subtotal;
  _sincronizarMesaConOrden(orden);
  return { ok: true, total: orden.total };
}

// ─── Control de horas (turnos por empleado) ──────────────────────────────────
// Array propio, separado de DB.turnos (que son los turnos de caja) para no
// contaminar getTurnoActivo. Misma forma que fromShift del backend.

const TURNOS_EMPLEADOS = [];

// Número finito o null (Number(null) es 0: una marcación sin GPS no puede
// quedar en lat/lng 0). Mismo criterio que _num en api.js.
const _numMock = (v) => {
  if (v === null || v === undefined || v === '' || typeof v === 'boolean') return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};

// Campos de evidencia (0050) vacíos — misma forma que fromShift del backend.
const EVIDENCIA_VACIA = {
  nota: null,
  fotoEntradaPath: null, fotoSalidaPath: null,
  latEntrada: null, lngEntrada: null, latSalida: null, lngSalida: null,
  precisionEntradaM: null, precisionSalidaM: null,
  distanciaEntradaM: null, distanciaSalidaM: null,
  enPuntoEntrada: null, enPuntoSalida: null,
  dispositivo: null,
};

// Foto de ejemplo para el demo: un SVG gris con silueta (sin base64 pesado,
// sin red). Sirve como "signed URL" de los paths que empiezan por `demo/`.
const FOTO_DEMO_DATAURL = 'data:image/svg+xml;utf8,' + encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" width="240" height="240" viewBox="0 0 240 240">'
  + '<rect width="240" height="240" fill="#6B6055"/>'
  + '<circle cx="120" cy="92" r="40" fill="#9A8A78"/>'
  + '<path d="M40 230c8-52 44-78 80-78s72 26 80 78z" fill="#9A8A78"/>'
  + '</svg>',
);

// Fotos subidas durante la sesión demo (path → dataURL). Solo memoria: una
// foto comprimida pesa ~80 KB en base64 y llenaría localStorage rápido.
const FOTOS_ASISTENCIA = new Map();

// Turnos de ejemplo: Juanes (admin, es "yo" en el demo) tiene un turno ABIERTO
// con foto + GPS en el punto, María uno cerrado con evidencia completa y
// Carlos uno cerrado FUERA del punto (para probar el filtro del admin).
(function _sembrarTurnosDemo() {
  const hoy = new Date();
  const hace = (dias, h, m = 0) => { const d = new Date(hoy); d.setDate(d.getDate() - dias); d.setHours(h, m, 0, 0); return d; };
  const lat = 6.2095, lng = -75.5676;   // punto del local (NEGOCIO_DEMO)
  const seeds = [
    {
      empleadoId: 'emp-1', empleadoNombre: 'Juanes Lizcano', roles: ['admin'],
      inicio: new Date(Math.max(hace(0, 7, 58).getTime(), hoy.getTime() - 3.2 * 3600000)), fin: null, duracionMin: null,
      fotoEntradaPath: 'demo/emp-1/entrada.jpg', latEntrada: lat + 0.0002, lngEntrada: lng + 0.0001,
      precisionEntradaM: 18, distanciaEntradaM: 25, enPuntoEntrada: true, dispositivo: 'Android · Chrome',
    },
    {
      empleadoId: 'emp-2', empleadoNombre: 'María García', roles: ['cajera'],
      inicio: hace(1, 8, 2), fin: hace(1, 16, 10), duracionMin: 8 * 60 + 8,
      fotoEntradaPath: 'demo/emp-2/entrada.jpg', latEntrada: lat + 0.0001, lngEntrada: lng - 0.0002,
      precisionEntradaM: 22, distanciaEntradaM: 31, enPuntoEntrada: true,
      fotoSalidaPath: 'demo/emp-2/salida.jpg', latSalida: lat - 0.0001, lngSalida: lng + 0.0001,
      precisionSalidaM: 15, distanciaSalidaM: 14, enPuntoSalida: true, dispositivo: 'iPhone · Safari',
    },
    {
      empleadoId: 'emp-3', empleadoNombre: 'Carlos Muñoz', roles: ['mesero'],
      inicio: hace(2, 9, 35), fin: hace(2, 15, 40), duracionMin: 6 * 60 + 5,
      fotoEntradaPath: null, latEntrada: 6.2442, lngEntrada: -75.5812,   // Laureles: ~4 km
      precisionEntradaM: 35, distanciaEntradaM: 4150, enPuntoEntrada: false,
      nota: 'Entrada: Vine de hacer una vuelta del negocio', dispositivo: 'Android · Chrome',
    },
  ];
  for (const s of seeds) {
    TURNOS_EMPLEADOS.push({ id: nextId(), baseTurno: 0, numOrdenes: 0, ...EVIDENCIA_VACIA, ...s });
  }
})();

// Marca entrada. Si ya tiene turno abierto, devuelve ese (no duplica).
// Acepta la evidencia opcional (0050) igual que api.js.
export async function iniciarTurnoEmpleado({
  empleadoId, empleadoNombre, roles, baseTurno = 0,
  fotoPath, lat, lng, precisionM, distanciaM, enPunto, dispositivo, nota,
} = {}) {
  await delay();
  const abierto = TURNOS_EMPLEADOS.find(t => t.empleadoId === empleadoId && t.fin === null);
  if (abierto) return { ...abierto };
  const turno = {
    id:             nextId(),
    empleadoId,
    empleadoNombre: empleadoNombre ?? null,
    baseTurno:      Number(baseTurno) || 0,
    inicio:         new Date(),
    fin:            null,
    duracionMin:    null,
    numOrdenes:     0,
    roles:          roles ?? ['cajera'],
    ...EVIDENCIA_VACIA,
    nota:              nota && String(nota).trim() ? `Entrada: ${String(nota).trim()}` : null,
    fotoEntradaPath:   fotoPath ?? null,
    latEntrada:        _numMock(lat),
    lngEntrada:        _numMock(lng),
    precisionEntradaM: _numMock(precisionM) !== null ? Math.round(_numMock(precisionM)) : null,
    distanciaEntradaM: _numMock(distanciaM) !== null ? Math.round(_numMock(distanciaM)) : null,
    enPuntoEntrada:    typeof enPunto === 'boolean' ? enPunto : null,
    dispositivo:       dispositivo ?? null,
  };
  TURNOS_EMPLEADOS.push(turno);
  return { ...turno };
}

// Cierra el turno abierto y devuelve el turno con duracionMin calculada.
// IMPORTANTE: siempre devuelve objeto (o null si no había turno abierto) —
// ControlHoras.jsx lee cerrado?.duracionMin del resultado.
export async function finalizarTurnoEmpleado(empleadoId, {
  fotoPath, lat, lng, precisionM, distanciaM, enPunto, dispositivo, nota,
} = {}) {
  await delay();
  const abierto = TURNOS_EMPLEADOS.find(t => t.empleadoId === empleadoId && t.fin === null);
  if (!abierto) return null;
  const ahora = new Date();
  abierto.fin         = ahora;
  abierto.duracionMin = Math.max(0, Math.round((ahora.getTime() - new Date(abierto.inicio).getTime()) / 60000));
  if (nota && String(nota).trim()) {
    abierto.nota = [abierto.nota, `Salida: ${String(nota).trim()}`].filter(Boolean).join(' · ');
  }
  if (fotoPath) abierto.fotoSalidaPath = fotoPath;
  if (_numMock(lat) !== null && _numMock(lng) !== null) {
    abierto.latSalida = _numMock(lat); abierto.lngSalida = _numMock(lng);
  }
  if (_numMock(precisionM) !== null) abierto.precisionSalidaM = Math.round(_numMock(precisionM));
  if (_numMock(distanciaM) !== null) abierto.distanciaSalidaM = Math.round(_numMock(distanciaM));
  if (typeof enPunto === 'boolean')        abierto.enPuntoSalida    = enPunto;
  if (dispositivo)                         abierto.dispositivo      = dispositivo;
  return { ...abierto };
}

// Últimos N turnos del empleado (historial de /mi-turno). Paridad con api.js.
export async function listarUltimosTurnos({ empleadoId, limite = 7 } = {}) {
  await delay();
  if (!empleadoId) return [];
  return TURNOS_EMPLEADOS
    .filter(t => t.empleadoId === empleadoId)
    .sort((a, b) => new Date(b.inicio) - new Date(a.inicio))
    .slice(0, Number(limite) || 7)
    .map(t => ({ ...t }));
}

// "Mi" empleado en el demo: por correo si coincide (probar como mesero/cajero)
// y, si el usuario es ADMIN sin fila propia, el empleado admin del negocio —
// en el backend real el dueño SIEMPRE tiene su team_member (trigger de 0001),
// así que el demo se comporta igual que producción.
export async function getMiEmpleado() {
  await delay();
  const user = usuarioActual();
  if (!user) return null;
  const negId = negocioActual();
  const mios = DB.empleados.filter(e => e.negocioId === negId);
  const porCorreo = mios.find(e => e.correo && user.email && e.correo.toLowerCase() === String(user.email).toLowerCase());
  if (porCorreo) return { ...porCorreo };
  if (String(user.role).toUpperCase() === 'ADMIN') {
    const admin = mios.find(e => (e.roles ?? []).includes('admin'));
    return admin ? { ...admin } : null;
  }
  return null;
}

// Foto de asistencia: en demo se guarda como dataURL en memoria y el "path"
// es la llave. Si el blob no se puede leer, cae a la foto gris de ejemplo.
export async function subirFotoAsistencia(blob, { empleadoId, tipo = 'entrada' } = {}) {
  await delay();
  if (!blob || !empleadoId) return null;
  const path = `${negocioActual() ?? 'neg-001'}/${empleadoId}/${Date.now()}-${tipo === 'salida' ? 'salida' : 'entrada'}.jpg`;
  let dataUrl = FOTO_DEMO_DATAURL;
  try {
    dataUrl = await new Promise((resolve, reject) => {
      const r = new FileReader();
      r.onload  = () => resolve(String(r.result));
      r.onerror = () => reject(new Error('lectura'));
      r.readAsDataURL(blob);
    });
  } catch { /* sin FileReader (tests) → foto de ejemplo */ }
  FOTOS_ASISTENCIA.set(path, dataUrl);
  return path;
}

// "Signed URL" del demo: el dataURL guardado, o la foto de ejemplo para los
// paths sembrados (`demo/...`).
export async function urlFotoAsistencia(path, segundosValidez = 3600) {
  await delay();
  if (!path) return null;
  return FOTOS_ASISTENCIA.get(path) ?? FOTO_DEMO_DATAURL;
}

// Config de asistencia del negocio demo (misma forma que api.js).
export async function getUbicacionNegocio() {
  await delay();
  const neg = DB.negocios[negocioActual()] ?? null;
  return {
    lat:          neg?.ubicacionLat ?? null,
    lng:          neg?.ubicacionLng ?? null,
    radioM:       Number(neg?.radioAsistenciaM ?? 150) || 150,
    requiereFoto: !!neg?.asistenciaRequiereFoto,
    requiereGps:  !!neg?.asistenciaRequiereGps,
    persistido:   true,
  };
}

export async function guardarUbicacionNegocio({ lat, lng, radioM, requiereFoto, requiereGps } = {}) {
  await delay();
  const negId = negocioActual();
  if (!negId || !DB.negocios[negId]) throw new Error('No autenticado.');
  const neg = DB.negocios[negId];
  if (lat !== undefined)          neg.ubicacionLat           = _numMock(lat);
  if (lng !== undefined)          neg.ubicacionLng           = _numMock(lng);
  if (radioM !== undefined)       neg.radioAsistenciaM       = Math.min(5000, Math.max(10, Math.round(Number(radioM) || 150)));
  if (requiereFoto !== undefined) neg.asistenciaRequiereFoto = !!requiereFoto;
  if (requiereGps !== undefined)  neg.asistenciaRequiereGps  = !!requiereGps;
  return getUbicacionNegocio();
}

// Lista los turnos del mes (cerrados + abiertos). mes es 0-indexed como api.js.
export async function listarTurnosMes({ ano, mes, empleadoId = null } = {}) {
  await delay();
  const y = ano ?? new Date().getFullYear();
  const m = mes ?? new Date().getMonth();
  return TURNOS_EMPLEADOS
    .filter(t => {
      const d = new Date(t.inicio);
      if (d.getFullYear() !== y || d.getMonth() !== m) return false;
      if (empleadoId && t.empleadoId !== empleadoId)   return false;
      return true;
    })
    .sort((a, b) => new Date(b.inicio) - new Date(a.inicio))
    .map(t => ({ ...t }));
}

// ─── Lealtad: clientes, recompensas y canjes ─────────────────────────────────

// Semilla de clientes frecuentes (misma forma que fromCliente del backend)
// para que /clientes y el autocompletar del POS no salgan vacíos en demo.
(function _sembrarClientesDemo() {
  const seeds = [
    { id: 'cli-1', celular: '3001234567', nombre: 'Laura Restrepo', visitas: 14, puntos: 120, ultimaVisita: new Date(Date.now() - 2 * 86400000), cumple: null, notas: null },
    { id: 'cli-2', celular: '3109876543', nombre: 'Andrés Cadavid', visitas: 9,  puntos: 75,  ultimaVisita: new Date(Date.now() - 5 * 86400000), cumple: null, notas: null },
    { id: 'cli-3', celular: '3155550123', nombre: 'Sofía Mejía',    visitas: 5,  puntos: 40,  ultimaVisita: new Date(Date.now() - 9 * 86400000), cumple: null, notas: null },
  ];
  for (const c of seeds) {
    if (!DB_CLIENTES[c.celular]) DB_CLIENTES[c.celular] = c;
  }
})();

// Busca por celular O nombre — para el autocompletar al cobrar.
export async function buscarClientes(query, limite = 5) {
  await delay();
  if (!query?.trim()) return [];
  const q = query.trim().toLowerCase();
  return Object.values(DB_CLIENTES)
    .filter(c => (c.celular ?? '').startsWith(q) || (c.nombre ?? '').toLowerCase().includes(q))
    .sort((a, b) => (b.puntos ?? 0) - (a.puntos ?? 0))
    .slice(0, limite)
    .map(c => ({ ...c }));
}

// Top clientes del negocio para la página /clientes.
export async function listarClientesFrecuentes({ limite = 100, orderBy = 'puntos' } = {}) {
  await delay();
  const lista = Object.values(DB_CLIENTES).map(c => ({ ...c }));
  if (orderBy === 'visitas')       lista.sort((a, b) => (b.visitas ?? 0) - (a.visitas ?? 0));
  else if (orderBy === 'reciente') lista.sort((a, b) => new Date(b.ultimaVisita ?? 0) - new Date(a.ultimaVisita ?? 0));
  else                             lista.sort((a, b) => (b.puntos ?? 0) - (a.puntos ?? 0));
  return lista.slice(0, limite);
}

// Recompensas configurables (misma forma que fromReward del backend).
let DB_RECOMPENSAS = [
  { id: 'rw-1', nombre: 'Café gratis',          descripcion: 'Un tinto o americano por la casa', puntosRequeridos: 50, tipo: 'producto', productoId: 'p-01', montoCop: null, porcentaje: null, activo: true, creadoEn: new Date('2025-02-01') },
  { id: 'rw-2', nombre: '$5.000 de descuento',  descripcion: null,                               puntosRequeridos: 80, tipo: 'monto',    productoId: null,   montoCop: 5000, porcentaje: null, activo: true, creadoEn: new Date('2025-02-01') },
];
const DB_CANJES = [];

export async function getRecompensas() {
  await delay();
  return [...DB_RECOMPENSAS].sort((a, b) => a.puntosRequeridos - b.puntosRequeridos);
}

export async function crearRecompensa(payload) {
  await delay();
  const reward = {
    id:               nextId(),
    nombre:           payload.nombre,
    descripcion:      payload.descripcion ?? null,
    puntosRequeridos: Number(payload.puntosRequeridos) || 1,
    tipo:             payload.tipo ?? 'producto',
    productoId:       payload.productoId ?? null,
    montoCop:         payload.montoCop ?? null,
    porcentaje:       payload.porcentaje ?? null,
    activo:           payload.activo ?? true,
    creadoEn:         new Date(),
  };
  DB_RECOMPENSAS.push(reward);
  return reward;
}

export async function actualizarRecompensa(id, payload) {
  await delay();
  const idx = DB_RECOMPENSAS.findIndex(r => r.id === id);
  if (idx === -1) throw new Error('reward_no_existe');
  const update = {};
  if (payload.nombre !== undefined)           update.nombre           = payload.nombre;
  if (payload.descripcion !== undefined)      update.descripcion      = payload.descripcion;
  if (payload.puntosRequeridos !== undefined) update.puntosRequeridos = Number(payload.puntosRequeridos);
  if (payload.tipo !== undefined)             update.tipo             = payload.tipo;
  if (payload.productoId !== undefined)       update.productoId       = payload.productoId;
  if (payload.montoCop !== undefined)         update.montoCop         = payload.montoCop;
  if (payload.porcentaje !== undefined)       update.porcentaje       = payload.porcentaje;
  if (payload.activo !== undefined)           update.activo           = payload.activo;
  DB_RECOMPENSAS[idx] = { ...DB_RECOMPENSAS[idx], ...update };
  return DB_RECOMPENSAS[idx];
}

export async function eliminarRecompensa(id) {
  await delay();
  DB_RECOMPENSAS = DB_RECOMPENSAS.filter(r => r.id !== id);
  return { ok: true };
}

// Canjea una recompensa: resta puntos y registra en historial (auditable).
export async function canjearRecompensa({ clienteId, rewardId, saleId = null }) {
  await delay();
  const reward = DB_RECOMPENSAS.find(r => r.id === rewardId);
  if (!reward) throw new Error('reward_no_existe');

  // Los clientes creados por registrarVisita no tienen id — buscamos por ambos.
  const cliente = Object.values(DB_CLIENTES).find(c => c.id === clienteId || c.celular === clienteId);
  if (!cliente) throw new Error('cliente_no_existe');

  const puntosActuales = Number(cliente.puntos ?? 0);
  if (puntosActuales < reward.puntosRequeridos) throw new Error('puntos_insuficientes');

  cliente.puntos = puntosActuales - reward.puntosRequeridos;

  // Historial en snake_case: el real devuelve las filas crudas de loyalty_canjes.
  const canje = {
    id:            nextId(),
    business_id:   negocioActual() ?? 'neg-001',
    cliente_id:    cliente.id ?? cliente.celular,
    reward_id:     reward.id,
    reward_nombre: reward.nombre,
    puntos_usados: reward.puntosRequeridos,
    sale_id:       saleId,
    created_at:    new Date().toISOString(),
  };
  DB_CANJES.unshift(canje);

  return { ok: true, canje, puntosRestantes: cliente.puntos };
}

export async function historialCanjes(clienteId) {
  await delay();
  return DB_CANJES.filter(c => c.cliente_id === clienteId).map(c => ({ ...c }));
}

// ─── Modo offline (venta directa + cola en memoria) ──────────────────────────
// En demo no hay red que se caiga, pero mantenemos la misma superficie: la
// cola vive en un array y crearVentaDirecta registra la venta como PAID
// (igual que hace createVenta) con idempotencia por localId.

let COLA_OFFLINE_MOCK = [];
const VENTAS_DIRECTAS_PROCESADAS = {};   // localId → respuesta (idempotencia)

export async function crearVentaDirecta(intent) {
  await delay();
  // Idempotente por localId, como la RPC mezo_venta_directa: reintentar es seguro.
  if (intent?.localId && VENTAS_DIRECTAS_PROCESADAS[intent.localId]) {
    return { ...VENTAS_DIRECTAS_PROCESADAS[intent.localId], idempotente: true };
  }

  const ahora     = new Date();
  const ordenId   = nextId();
  const items     = (intent?.items ?? []).map(i => _lineaDesdeItem(i, ordenId));
  const subtotal  = items.reduce((s, l) => s + l.subtotal, 0);
  const tip       = Math.round(Number(intent?.tip ?? 0));
  const descuento = Math.round(Number(intent?.descuento ?? 0));
  const total     = Math.max(0, subtotal + tip - descuento);

  // Registrar la venta como orden PAID, igual que el flujo online del POS.
  DB.ordenes.unshift({
    id:            ordenId,
    negocioId:     negocioActual() ?? 'neg-001',
    status:        'PAID',
    estadoCocina:  null,
    cocinaEn:      null,
    items,
    subtotal,
    tip:           tip || null,
    total,
    paymentMethod: intent?.paymentMethod ?? 'CASH',
    comentario:    (intent?.comentario ?? '').trim().slice(0, 200) || null,
    metodoNombre:  (intent?.metodoNombre ?? '').trim().slice(0, 40) || null,
    pagos:         Array.isArray(intent?.pagos) ? intent.pagos : [],
    saleNumber:    nextSale(),
    tableId:       intent?.tableId ?? null,
    employeeName:  null,
    shiftId:       null,
    createdAt:     ahora,
  });

  const venta = {
    id:             nextId(),
    order_id:       ordenId,
    payment_method: intent?.paymentMethod ?? 'CASH',
    subtotal,
    tip:            tip || null,
    total,
    created_at:     ahora.toISOString(),
    idempotente:    false,
  };
  if (intent?.localId) VENTAS_DIRECTAS_PROCESADAS[intent.localId] = venta;
  return venta;
}

// Encola una venta hecha "sin internet". Devuelve el intent con su localId
// (misma forma que el real; síncrona como el real).
export function encolarVentaOffline(intent) {
  const venta = {
    ...intent,
    localId:    intent?.localId ?? `loc_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`,
    businessId: intent?.businessId ?? negocioActual() ?? 'neg-001',
    createdAt:  new Date().toISOString(),
  };
  COLA_OFFLINE_MOCK.push(venta);
  return venta;
}

export function ventasOfflinePendientes() { return [...COLA_OFFLINE_MOCK]; }
export function contarVentasOffline()     { return COLA_OFFLINE_MOCK.length; }

// Reenvía la cola mock. Devuelve { ok, fail } como el real.
export async function sincronizarVentasOffline() {
  let ok = 0, fail = 0;
  for (const venta of [...COLA_OFFLINE_MOCK]) {
    try {
      await crearVentaDirecta(venta);
      COLA_OFFLINE_MOCK = COLA_OFFLINE_MOCK.filter(v => v.localId !== venta.localId);
      ok++;
    } catch {
      fail++;
    }
  }
  return { ok, fail };
}

// ─── Inventario en memoria (paridad con inventarioService, 0051) ─────────────
// El demo público (/demo) y el modo mock corren contra ESTE inventario:
// inventarioService delega aquí cuando USE_MOCK. Misma shape que el servicio
// real (items con stockActual/stockMaximo/stockMinimo, movimientos con origen,
// kardex con nombre del ítem y "por", carga maestra por nombre normalizado).

const INVENTARIO_INIT = [
  { id: 'inv-01', nombre: 'Café en grano',      unidad: 'g',  stockActual: 3200, stockMaximo: 5000,  stockMinimo: 1000, categoria: 'Bebidas', precioCosto: 90   },
  { id: 'inv-02', nombre: 'Leche entera',       unidad: 'ml', stockActual: 9500, stockMaximo: 24000, stockMinimo: 4000, categoria: 'Bebidas', precioCosto: 4.5  },
  { id: 'inv-03', nombre: 'Azúcar',             unidad: 'g',  stockActual: 1800, stockMaximo: 5000,  stockMinimo: 1000, categoria: 'Insumos', precioCosto: 5    },
  { id: 'inv-04', nombre: 'Panela',             unidad: 'g',  stockActual: 2500, stockMaximo: 4000,  stockMinimo: 800,  categoria: 'Insumos', precioCosto: 6    },
  { id: 'inv-05', nombre: 'Pan de bono',        unidad: 'ud', stockActual: 14,   stockMaximo: 60,    stockMinimo: 20,   categoria: 'Insumos', precioCosto: 800  },
  { id: 'inv-06', nombre: 'Croissants',         unidad: 'ud', stockActual: 22,   stockMaximo: 40,    stockMinimo: 10,   categoria: 'Insumos', precioCosto: 1500 },
  { id: 'inv-07', nombre: 'Lulo',               unidad: 'g',  stockActual: 1200, stockMaximo: 3000,  stockMinimo: 500,  categoria: 'Insumos', precioCosto: 8    },
  { id: 'inv-08', nombre: 'Vasos para llevar',  unidad: 'ud', stockActual: 180,  stockMaximo: 500,   stockMinimo: 100,  categoria: 'Empaque', precioCosto: 250  },
];

// Recetas estándar de algunos productos del demo → cobertura "9 de 23".
const RECETAS_DEMO = {
  'p-01': [{ itemId: 'inv-01', cantidadPorVenta: 9 }],
  'p-02': [{ itemId: 'inv-01', cantidadPorVenta: 18 }],
  'p-03': [{ itemId: 'inv-01', cantidadPorVenta: 9 },  { itemId: 'inv-02', cantidadPorVenta: 120 }],
  'p-04': [{ itemId: 'inv-01', cantidadPorVenta: 18 }, { itemId: 'inv-02', cantidadPorVenta: 150 }],
  'p-05': [{ itemId: 'inv-01', cantidadPorVenta: 18 }, { itemId: 'inv-02', cantidadPorVenta: 200 }],
  'p-07': [{ itemId: 'inv-04', cantidadPorVenta: 30 }],
  'p-08': [{ itemId: 'inv-07', cantidadPorVenta: 120 }, { itemId: 'inv-03', cantidadPorVenta: 20 }],
  'p-13': [{ itemId: 'inv-06', cantidadPorVenta: 1 }],
  'p-14': [{ itemId: 'inv-05', cantidadPorVenta: 1 }],
};
DB.productos = DB.productos.map(p => (RECETAS_DEMO[p.id]
  ? { ...p, inventarioAsociado: { activo: true, items: RECETAS_DEMO[p.id] } }
  : p));

const DB_INVENTARIO = INVENTARIO_INIT.map(i => ({ ...i, negocioId: 'neg-001', creadoEn: new Date(Date.now() - 7 * 86400000).toISOString(), actualizadoEn: new Date().toISOString() }));
let DB_KARDEX = [];

function _invNormalizar(s) {
  return String(s ?? '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim();
}
function _invItemsNegocio() {
  const negId = negocioActual() ?? 'neg-001';
  return DB_INVENTARIO.filter(i => i.negocioId === negId);
}
function _invRegistrarMov(item, { tipo, origen, cantidad, stockResultante, nota = '', orderId = null, por = null, fecha = null }) {
  const mov = {
    id: nextId(), itemId: item.id, tipo, origen, cantidad: Number(cantidad), stockResultante: Number(stockResultante),
    nota, fecha: fecha ?? new Date().toISOString(), orderId, userId: por ? 'mock-user' : null, por,
    negocioId: item.negocioId,
  };
  DB_KARDEX.unshift(mov);
  return mov;
}

// Semilla de kardex: carga maestra hace 7 días + ventas diarias + una compra,
// un ajuste y una merma. Así el demo muestra el kardex lleno.
(function _semillaKardex() {
  const hace = (dias, hora = 9) => { const d = new Date(); d.setDate(d.getDate() - dias); d.setHours(hora, 15, 0, 0); return d.toISOString(); };
  const [cafe, leche, azucar, , bono, crois] = DB_INVENTARIO;
  // Eventos con signo (del más viejo al más nuevo). El stock inicial de la
  // carga maestra se deriva para que el kardex TERMINE en el stock actual.
  const eventos = [];
  const venta = (item, cantidad, fecha, orden, por = 'María García') =>
    eventos.push({ item, tipo: 'venta', origen: 'venta', cantidad: -cantidad, fecha, orderId: orden, nota: `Orden ${orden}`, por });
  for (let d = 6; d >= 1; d--) {
    for (const h of [8, 11, 16]) {
      const orden = `mock-${4000 + d * 10 + h}`;
      venta(cafe, 108, hace(d, h), orden); venta(leche, 450, hace(d, h), orden); venta(azucar, 60, hace(d, h), orden);
    }
    venta(bono, 5, hace(d, 10), `mock-${4100 + d}`, 'Carlos Muñoz');
    venta(crois, 3, hace(d, 10), `mock-${4100 + d}`, 'Carlos Muñoz');
  }
  eventos.push({ item: leche,  tipo: 'reposicion', origen: 'reposicion', cantidad: 6000, fecha: hace(3, 7),  nota: 'Compra proveedor', por: 'Juanes Lizcano' });
  eventos.push({ item: crois,  tipo: 'perdida',    origen: 'merma',      cantidad: -2,   fecha: hace(2, 18), nota: 'Merma: dos croissants quemados', por: 'Juanes Lizcano' });
  eventos.push({ item: azucar, tipo: 'ajuste',     origen: 'ajuste',     cantidad: -140, fecha: hace(1, 20), nota: 'Conteo físico', por: 'Juanes Lizcano' });

  for (const it of DB_INVENTARIO) {
    const evs = eventos.filter(e => e.item === it).sort((a, b) => new Date(a.fecha) - new Date(b.fecha));
    let stock = it.stockActual - evs.reduce((s, e) => s + e.cantidad, 0);   // stock tras la carga maestra
    _invRegistrarMov(it, { tipo: 'reposicion', origen: 'carga_maestra', cantidad: stock, stockResultante: stock, nota: 'Carga maestra (conteo físico)', por: 'Juanes Lizcano', fecha: hace(6, 7) });
    for (const e of evs) {
      stock += e.cantidad;
      _invRegistrarMov(it, { ...e, stockResultante: stock });
    }
  }
  DB_KARDEX.sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
})();

async function _invListar() {
  return _invItemsNegocio().map(i => ({ ...i })).sort((a, b) => a.nombre.localeCompare(b.nombre));
}
async function _invObtener(id) {
  const it = _invItemsNegocio().find(i => i.id === id);
  return it ? { ...it } : null;
}
async function _invCrear({ nombre, unidad, stockActual, stockMaximo, stockMinimo, categoria, precioCosto }, { origen = 'reposicion', nota = 'Stock inicial' } = {}) {
  const item = {
    id: nextId(), negocioId: negocioActual() ?? 'neg-001', nombre,
    unidad: unidad || 'ud', stockActual: Number(stockActual) || 0,
    stockMaximo: Number(stockMaximo) || Number(stockActual) || 100,
    stockMinimo: stockMinimo == null || stockMinimo === '' ? null : Number(stockMinimo),
    categoria: categoria || 'Otros', precioCosto: Number(precioCosto) || 0,
    creadoEn: new Date().toISOString(), actualizadoEn: new Date().toISOString(),
  };
  DB_INVENTARIO.push(item);
  if (item.stockActual > 0) _invRegistrarMov(item, { tipo: 'reposicion', origen, cantidad: item.stockActual, stockResultante: item.stockActual, nota, por: 'Juanes Lizcano' });
  return { ...item };
}
async function _invActualizar(id, cambios) {
  const it = DB_INVENTARIO.find(i => i.id === id);
  if (!it) return null;
  for (const k of ['nombre', 'unidad', 'categoria']) if (cambios[k] !== undefined) it[k] = cambios[k];
  for (const k of ['stockActual', 'stockMaximo', 'precioCosto']) if (cambios[k] !== undefined) it[k] = Number(cambios[k]) || 0;
  if (cambios.stockMinimo !== undefined) it.stockMinimo = cambios.stockMinimo == null ? null : Number(cambios.stockMinimo);
  it.actualizadoEn = new Date().toISOString();
  return { ...it };
}
async function _invEliminar(id) {
  const idx = DB_INVENTARIO.findIndex(i => i.id === id);
  if (idx >= 0) DB_INVENTARIO.splice(idx, 1);
  DB_KARDEX = DB_KARDEX.filter(m => m.itemId !== id);
  return { ok: true };
}
async function _invReponer(id, cantidad, nota = '') {
  const it = DB_INVENTARIO.find(i => i.id === id);
  if (!it) return null;
  const c = Number(cantidad) || 0;
  it.stockActual += c;
  _invRegistrarMov(it, { tipo: 'reposicion', origen: 'reposicion', cantidad: c, stockResultante: it.stockActual, nota, por: 'Juanes Lizcano' });
  return { ...it };
}
async function _invAjustar(id, nuevoStock, nota = '') {
  const it = DB_INVENTARIO.find(i => i.id === id);
  if (!it) return null;
  const nuevo = Number(nuevoStock) || 0;
  const dif = nuevo - it.stockActual;
  it.stockActual = nuevo;
  const esMerma = dif < 0 && /merma|perdid|dañad|danad|vencid|roto|derram/i.test(nota || '');
  _invRegistrarMov(it, { tipo: esMerma ? 'perdida' : 'ajuste', origen: esMerma ? 'merma' : 'ajuste', cantidad: dif, stockResultante: nuevo, nota, por: 'Juanes Lizcano' });
  return { ...it };
}
async function _invDescontarPorVenta(id, cantidad, ordenId) {
  const it = DB_INVENTARIO.find(i => i.id === id);
  if (!it) return null;
  const c = Number(cantidad) || 0;
  it.stockActual = Math.max(0, it.stockActual - c);
  _invRegistrarMov(it, { tipo: 'venta', origen: 'venta', cantidad: -c, stockResultante: it.stockActual, nota: ordenId ? `Orden ${ordenId}` : '', orderId: ordenId ?? null, por: 'María García' });
  return { ...it };
}
async function _invMovimientos(itemId) {
  return DB_KARDEX.filter(m => m.itemId === itemId).slice(0, 200).map(m => ({ ...m }));
}
async function _invConsumoReciente(dias = 14) {
  const desde = Date.now() - dias * 86400000;
  const acc = {};
  for (const m of DB_KARDEX) {
    if (m.origen !== 'venta' || new Date(m.fecha).getTime() < desde) continue;
    if (!acc[m.itemId]) acc[m.itemId] = { total: 0, primer: m.fecha };
    acc[m.itemId].total += Math.abs(m.cantidad);
    if (m.fecha < acc[m.itemId].primer) acc[m.itemId].primer = m.fecha;
  }
  const out = {};
  for (const [id, v] of Object.entries(acc)) {
    const span = Math.max(1, Math.min(dias, Math.ceil((Date.now() - new Date(v.primer).getTime()) / 86400000)));
    out[id] = { total: v.total, porDia: v.total / span };
  }
  return out;
}
async function _invKardex({ desde, hasta, origen, itemId, limite = 1000 } = {}) {
  await delay();
  const negId = negocioActual() ?? 'neg-001';
  const itemsById = Object.fromEntries(DB_INVENTARIO.map(i => [i.id, i]));
  const tDesde = desde ? new Date(desde).getTime() : null;
  const tHasta = hasta ? new Date(hasta).getTime() : null;
  return DB_KARDEX
    .filter(m => m.negocioId === negId)
    .filter(m => (!tDesde || new Date(m.fecha).getTime() >= tDesde) && (!tHasta || new Date(m.fecha).getTime() <= tHasta))
    .filter(m => !origen || m.origen === origen)
    .filter(m => !itemId || m.itemId === itemId)
    .slice(0, limite)
    .map(m => ({ ...m, itemNombre: itemsById[m.itemId]?.nombre ?? '—', unidad: itemsById[m.itemId]?.unidad ?? '' }));
}
async function _invCargarMaestro(filas, { modo = 'reemplazar', nota = '' } = {}) {
  await delay();
  const notaMov = nota || (modo === 'sumar' ? 'Carga maestra (compra)' : 'Carga maestra (conteo físico)');
  const out = { creados: 0, actualizados: 0, sinCambio: 0, errores: [] };
  for (const f of filas ?? []) {
    const ex = _invItemsNegocio().find(i => _invNormalizar(i.nombre) === _invNormalizar(f.nombre));
    if (!ex) {
      await _invCrear({
        nombre: String(f.nombre).trim(), unidad: f.unidad || 'ud', stockActual: f.stock,
        stockMaximo: Math.max(Number(f.stock) || 0, Number(f.minimo) * 2 || 0, 10),
        stockMinimo: f.minimo, categoria: f.categoria || 'Insumos', precioCosto: f.costo ?? 0,
      }, { origen: 'carga_maestra', nota: notaMov });
      out.creados++;
      continue;
    }
    const antes = Number(ex.stockActual) || 0;
    const despues = modo === 'sumar' ? antes + Number(f.stock) : Number(f.stock);
    const dif = despues - antes;
    const cambios = {};
    if (dif !== 0) cambios.stockActual = despues;
    if (f.unidad && f.unidad !== ex.unidad) cambios.unidad = f.unidad;
    if (f.costo != null && Number(f.costo) !== Number(ex.precioCosto || 0)) cambios.precioCosto = f.costo;
    if (f.minimo != null && Number(f.minimo) !== Number(ex.stockMinimo ?? NaN)) cambios.stockMinimo = f.minimo;
    if (f.categoria && f.categoria !== ex.categoria) cambios.categoria = f.categoria;
    if (despues > (Number(ex.stockMaximo) || 0)) cambios.stockMaximo = despues;
    if (Object.keys(cambios).length === 0) { out.sinCambio++; continue; }
    await _invActualizar(ex.id, cambios);
    if (dif !== 0) _invRegistrarMov(ex, { tipo: modo === 'sumar' ? 'reposicion' : 'ajuste', origen: 'carga_maestra', cantidad: dif, stockResultante: despues, nota: notaMov, por: 'Juanes Lizcano' });
    out.actualizados++;
  }
  return out;
}
async function _invCoberturaRecetas() {
  const negId = negocioActual() ?? 'neg-001';
  const activos = DB.productos.filter(p => p.negocioId === negId && p.disponible !== false);
  const descuenta = (p) => !!(p.inventarioAsociado?.activo && (p.inventarioAsociado.items ?? []).some(it => it?.itemId && Number(it.cantidadPorVenta) > 0));
  const sinReceta = activos.filter(p => !descuenta(p)).map(p => ({ id: p.id, nombre: p.nombre }));
  return { totalProductos: activos.length, conReceta: activos.length - sinReceta.length, sinReceta };
}

export const inventarioMock = {
  listar: _invListar, obtener: _invObtener, crear: _invCrear, actualizar: _invActualizar, eliminar: _invEliminar,
  reponer: _invReponer, ajustar: _invAjustar, descontarPorVenta: _invDescontarPorVenta, movimientos: _invMovimientos,
  consumoReciente: _invConsumoReciente, kardex: _invKardex, cargarMaestro: _invCargarMaestro, coberturaRecetas: _invCoberturaRecetas,
};

// Paridad con api.js (barrel): carga maestra, kardex y cobertura.
export async function cargarInventarioMaestro(filas, opts) { return _invCargarMaestro(filas, opts); }
export async function getKardexInventario(filtros)         { return _invKardex(filtros); }
export async function getCoberturaRecetas()                { return _invCoberturaRecetas(); }

// ─── Checklist + Llave del local (0058) — paridad con api.js ─────────────

const _registrosChecklist = [];

export async function guardarChecklistConfig(cfg) {
  await delay();
  const neg = DB.negocios[negocioActual()];
  if (neg) neg.checklistConfig = cfg;
  return cfg;
}

export async function vincularClienteVenta(saleId, cliente) {
  await delay();
  const o = DB.ordenes.find((x) => x.ventaId === saleId || `sale-${x.id}` === saleId);
  if (!o || !cliente) return false;
  o.clienteVenta = { id: cliente.id ?? null, nombre: cliente.nombre ?? null, celular: cliente.celular ?? null };
  return true;
}

export async function guardarMetodosPago(cfg) {
  await delay();
  const neg = DB.negocios[negocioActual()];
  if (neg) neg.metodosPago = cfg;
  return cfg;
}

// ─── Descuentos con autorización (0067) ─────────────────────────────────────
export async function guardarDescuentosConfig(cfg) {
  await delay();
  const limpio = sanearDescuentosConfig(cfg);
  const neg = DB.negocios[negocioActual()];
  if (neg) neg.descuentosConfig = limpio;
  return limpio;
}

// PIN de la demo: cada empleado de EMPLEADOS_INIT trae el suyo (1234 / 2345 / 3456).
export async function verificarPinEmpleado(empleadoId, pin) {
  await delay();
  const e = DB.empleados.find((x) => x.id === empleadoId);
  const limpio = String(pin ?? '').replace(/\D/g, '').slice(0, 4);
  if (!e || !e.pin) return { ok: false, motivo: 'sin_pin', intentosRestantes: null, esperaSegundos: 0 };
  if (e.pin === limpio) return { ok: true, motivo: 'ok', intentosRestantes: null, esperaSegundos: 0 };
  return { ok: false, motivo: 'incorrecto', intentosRestantes: 4, esperaSegundos: 0 };
}

// ─── Propinas repartidas (0067) — mismas formas que las RPC ─────────────────
const _diaISO = (d) => { const x = new Date(d); return `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, '0')}-${String(x.getDate()).padStart(2, '0')}`; };
function _ventasPropina(desde, hasta) {
  return DB.ordenes.filter((o) => o.status === 'PAID' && o.createdAt).map((o) => {
    const dia = _diaISO(o.createdAt);
    const tip = Number(o.tip?.amount ?? o.tip ?? 0) || 0;
    return { dia, tip, medio: o.metodoNombre ?? o.paymentMethod ?? 'CASH', canal: o.paymentMethod ?? 'CASH' };
  }).filter((v) => v.dia >= desde && v.dia <= hasta);
}
export async function getPropinasResumen({ desde, hasta }) {
  await delay();
  const v = _ventasPropina(desde, hasta);
  const dias = [];
  for (let d = new Date(`${desde}T12:00:00`); _diaISO(d) <= hasta; d.setDate(d.getDate() + 1)) {
    const k = _diaISO(d);
    const del = v.filter((x) => x.dia === k);
    dias.push({ dia: k, propinas: del.reduce((s, x) => s + x.tip, 0), ventas: del.length });
  }
  const porMedio = {};
  v.forEach((x) => { if (x.tip > 0) { const k = `${x.medio}|${x.canal}`; porMedio[k] = (porMedio[k] ?? 0) + x.tip; } });
  const ini = new Date(`${desde}T00:00:00`).getTime(); const fin = new Date(`${hasta}T23:59:59`).getTime();
  // TURNOS_EMPLEADOS = turnos de asistencia (Mi turno); DB.turnos son los de caja.
  const horasDe = (empId) => TURNOS_EMPLEADOS.filter((t) => t.empleadoId === empId).reduce((s, t) => {
    const a = Math.max(new Date(t.inicio).getTime(), ini); const b = Math.min(t.fin ? new Date(t.fin).getTime() : Date.now(), fin);
    return s + Math.max(0, (b - a) / 3600000);
  }, 0);
  return {
    desde, hasta,
    total: v.reduce((s, x) => s + x.tip, 0), ventas: v.length, con_propina: v.filter((x) => x.tip > 0).length,
    por_dia: dias,
    por_medio: Object.entries(porMedio).map(([k, p]) => { const [medio, canal] = k.split('|'); return { medio, canal, propinas: p }; }).sort((a, b) => b.propinas - a.propinas),
    empleados: DB.empleados.filter((e) => e.activo !== false).map((e) => ({
      empleado_id: e.id, nombre: e.nombre, rol: (e.roles?.[0] ?? 'WAITER').toUpperCase(), status: 'ACTIVE',
      horas: Math.round(horasDe(e.id) * 100) / 100,
      turnos: TURNOS_EMPLEADOS.filter((t) => t.empleadoId === e.id && new Date(t.inicio).getTime() <= fin && (t.fin ? new Date(t.fin).getTime() : Date.now()) >= ini).length,
    })),
    repartos_previos: (DB.repartos ?? []).filter((r) => !r.anulado_en && r.desde <= hasta && r.hasta >= desde)
      .map((r) => ({ id: r.id, desde: r.desde, hasta: r.hasta, modo: r.modo, total_repartido: r.total_repartido, created_at: r.created_at })),
  };
}
export async function repartirPropinas({ desde, hasta, modo, detalle, nota }) {
  await delay();
  const total = _ventasPropina(desde, hasta).reduce((s, x) => s + x.tip, 0);
  const det = (detalle ?? []).map((d) => {
    const e = DB.empleados.find((x) => x.id === d.empleado_id);
    if (!e) throw new Error('El empleado no es de este negocio');
    return { empleado_id: e.id, nombre: e.nombre, rol: (e.roles?.[0] ?? 'WAITER').toUpperCase(), horas: d.horas ?? null, peso: d.peso ?? null, monto: Math.max(0, Math.round(Number(d.monto) || 0)) };
  });
  const rep = det.reduce((s, d) => s + d.monto, 0);
  if (rep > total) throw new Error(`El reparto ($${rep.toLocaleString('es-CO')}) supera las propinas recaudadas ($${total.toLocaleString('es-CO')})`);
  const row = { id: 'rep-' + Date.now(), business_id: 'neg-001', desde, hasta, total_propinas: total, total_repartido: rep, modo, detalle: det, nota: nota ?? null,
    creado_por: 'Juanes Lizcano', creado_por_id: 'emp-1', anulado_en: null, anulado_por: null, anulado_motivo: null, created_at: new Date().toISOString() };
  DB.repartos = [row, ...(DB.repartos ?? [])];
  return row;
}
export async function listarRepartosPropinas(limite = 30) { await delay(); return (DB.repartos ?? []).slice(0, limite); }
export async function misPropinas() {
  await delay();
  const yo = 'emp-1';
  const mios = (DB.repartos ?? []).filter((r) => !r.anulado_en).flatMap((r) => r.detalle.filter((d) => d.empleado_id === yo)
    .map((d) => ({ id: r.id, desde: r.desde, hasta: r.hasta, modo: r.modo, created_at: r.created_at, nota: r.nota, monto: d.monto, horas: d.horas })));
  const hace30 = Date.now() - 30 * 86400000;
  return { total_30d: mios.filter((m) => new Date(m.created_at).getTime() >= hace30).reduce((s, m) => s + m.monto, 0), total_90d: mios.reduce((s, m) => s + m.monto, 0), repartos: mios };
}
export async function anularRepartoPropinas(id, motivo) {
  await delay();
  const r = (DB.repartos ?? []).find((x) => x.id === id);
  if (!r || r.anulado_en) return false;
  r.anulado_en = new Date().toISOString(); r.anulado_por = 'juanes@cafemezo.co'; r.anulado_motivo = motivo ?? null;
  return true;
}

export async function registrarChecklist({ turno, tareas, observaciones, empleadoId, empleadoNombre }) {
  await delay();
  const r = {
    id: 'chk-' + Date.now(), turno,
    empleadoNombre: empleadoNombre ?? null, empleadoId: empleadoId ?? null,
    tareas: tareas ?? [], observaciones: observaciones ?? null,
    creadoEn: new Date().toISOString(),
  };
  _registrosChecklist.unshift(r);
  return r;
}

export async function getRegistrosChecklist() {
  await delay();
  return [..._registrosChecklist];
}

export async function activarLlaveAsistencia(activar) {
  await delay();
  const neg = DB.negocios[negocioActual()];
  if (neg) neg.asistenciaRequiereLlave = !!activar;
  return { ok: true, activa: !!activar };
}

// Mismo esquema que el servidor (ventana de 45 s) para que la demo se sienta
// igual; el "secreto" del mock es fijo porque aquí no hay nada que proteger.
function _codigoLlaveMock(ventana) {
  let h = 0;
  const base = 'demo-llave-' + ventana;
  for (let i = 0; i < base.length; i++) h = (h * 31 + base.charCodeAt(i)) >>> 0;
  return String(h % 1000000).padStart(6, '0');
}

export async function getLlaveActual() {
  await delay();
  const neg = DB.negocios[negocioActual()];
  if (!neg?.asistenciaRequiereLlave) return null;
  const ahora = Math.floor(Date.now() / 1000);
  return { codigo: _codigoLlaveMock(Math.floor(ahora / 45)), expiraEnSeg: 45 - (ahora % 45) };
}

export async function canjearLlaveAsistencia(codigo) {
  await delay();
  const neg = DB.negocios[negocioActual()];
  if (!neg?.asistenciaRequiereLlave) return { ok: true };
  const v = Math.floor(Math.floor(Date.now() / 1000) / 45);
  const ok = [v - 1, v, v + 1].some((w) => _codigoLlaveMock(w) === String(codigo ?? '').trim());
  return ok ? { ok: true } : { ok: false, motivo: 'codigo_incorrecto' };
}
